
import { Box, Chip, Grid, InputAdornment, Tooltip, Typography } from '@mui/material'
import FormControl from '@mui/material/FormControl'
import FormControlLabel from '@mui/material/FormControlLabel'
import RadioGroup from '@mui/material/RadioGroup'
import { styled } from '@mui/material/styles'
import { formAppointment } from 'app/slice/appointment.slice'
import { resetModal } from 'app/slice/modal.slice'
import { PACKAGE_ADDONS } from 'constants/package'
import { ThemeIcon, colors } from 'constants/theme'
import _ from 'lodash'
import moment from 'moment'
import { useCallback, useEffect, useRef, useState } from 'react'
import { ButtonGroup, Col, Dropdown, DropdownButton, Image, Row } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory, useLocation, } from 'react-router-dom'
import { checkPackage, getBranch, toBuddhistYear } from "utils/app.utils"

/** TRANSLATION*/
import { useTranslation } from 'react-i18next'

/** ICON || IMAGE */
import cancel from 'assets/icon/appointment/status-btn/cancel.svg'
import changeSchedule from 'assets/icon/appointment/status-btn/changeSchedule.svg'
import enter from 'assets/icon/appointment/status-btn/enter.svg'
import notConnect from 'assets/icon/appointment/status-btn/notConnect.svg'
import userCheckFalse from 'assets/icon/appointment/status-btn/userCheckFalse.svg'
import userCheckTrue from 'assets/icon/appointment/status-btn/userCheckTrue.svg'
import { Icons, icons } from 'constants/images'

/** API */
import AppointmentApi, { AppointmentInterface, ValidateAppointmentInterface } from 'api/counter/appointment.api'
import RegisterApi from 'api/counter/register.api'
import ClinicApi from 'api/master/clinic.api'
import AppointmentDurationApi from 'api/setting/defaults/appointment-duration.api'

/** COMPONENT */
import MenuItem from '@mui/material/MenuItem'
import ComponentApi, { TreatmentItemsInterface } from 'api/components-api'
import DoctorScheduleApi, { SchedulesAllProps } from 'api/counter/doctor-schedule.api'
import InputRadio from 'component/Input/InputRadio'
import InputSecondNewDatePicker from 'component/Input/InputSecondNewDatePicker'
import InputTextarea from 'component/Input/InputTextarea'
import InputTextField from 'component/Input/InputTextField'
import Loading from 'component/Loading'
import ModalCustom from 'component/ModalCustom/ModalCustom'
import { notiError, notiSuccess } from 'component/notifications/notifications'
import SearchPatients from 'component/SearchPatients'
import AutocompleteSelect from 'component/Select/AutocompleteSelect'
import BasicSelect from 'component/Select/BasicSelect'
import { DentistsInterface } from 'features/counter/appointment/appointment-interface'


/** STYLE */
import { faSearch, faTimes } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import CancelRoundedIcon from '@mui/icons-material/CancelRounded'
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined'
import PlaylistAddOutlinedIcon from '@mui/icons-material/PlaylistAddOutlined'
import ReceiptLongOutlinedIcon from '@mui/icons-material/ReceiptLongOutlined'
import ReplayOutlinedIcon from '@mui/icons-material/ReplayOutlined'
import ScienceIcon from '@mui/icons-material/Science'
import TaskAltOutlinedIcon from '@mui/icons-material/TaskAltOutlined'


import ButtonCustom from 'component/Button/ButtonCustom'
import InputTimePickerAppointment from 'component/Input/InputTimePickerAppointment'
import 'features/counter/appointment/style.css'
import { TIME_APPOINTMENT } from 'features/setting/branch-service-point/branch/form-branch'
import MainButton from 'new-components/buttons/main-button'
import TextAreaInput from 'new-components/inputs/text-area-input'
import TextInput from 'new-components/inputs/text-input'
import AlertModal from 'new-components/modal/alert-modal'
import PageModal from 'new-components/modal/page-modal'
import SnackbarComponent from 'new-components/snackbar/snackbar-component'
import { dateToView } from 'utils/date.utils'
import useWindowSize from 'utils/useWindowSize'
import { isDelete, } from 'utils/verification.utils'
import PopupMessageAppointMent from './popup-message-appointment'
import { ModalSlice, ModalSliceFooter, ModalSliceTitle } from './style'



type AlertType = "error" | "warning" | "success"

interface AlertAction {
  onClick: () => void
  title: string
}

interface ConfigAlert {
  isOpen: boolean
  title: string
  message?: string
  type: AlertType
  children?: React.ReactNode[]
  onCancel: AlertAction
  onSubmit: AlertAction
  handleClose: () => void
}


const initialConfigAlert: ConfigAlert = {
  isOpen: false,
  title: '',
  message: '',
  type: 'error',
  children: [],
  onCancel: { onClick: () => undefined, title: '' },
  onSubmit: { onClick: () => undefined, title: '' },
  handleClose: () => undefined
}

const LabelAddPatient = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  padding: '5px 0px 5px 16px',
  fontSize: '18px',
  fontWeight: 700,
  marginLeft: '30px',
  borderRadius: '4px',
  width: '100%',
  backgroundColor: colors.themeSecondColor10,
  [theme.breakpoints.down('lg')]: {

    marginLeft: '0px'
  }
}))

const ButtonAddPatient = styled('button')(({ theme }) => ({
  width: 'fit-content',
  height: '42px',
  borderRadius: '4px',
  border: `solid 1px ${colors.themeSecondColor}`,
  backgroundColor: colors.white,
  fontSize: '16px',
  color: colors.themeSecondColor,
  '&.add-disabled': {
    color: colors.disabledGray,
    borderColor: colors.disabledGray
  },
  '& img': {
    verticalAlign: 'top',
    marginTop: '2px'
  }
}))

const CustomBody = styled('div')<{ apStatus?: any }>(({ theme, apStatus }) => ({
  '& .dropdownColor': {
    height: 43,
    '& button': {
      backgroundColor: `${apStatus?.color || colors.lightGray} !important`,
      borderColor: `${apStatus?.color || colors.lightGray} !important`,
      color: `${apStatus?.color ? colors.white : colors.black} !important`,
      boxShadow: 'none !important',
      '& img': {
        width: '24px',
        maxWidth: '24px',
        maxHeight: '24px'
      },
      '&::after': {
        marginLeft: '0.5em',
        verticalAlign: '0.2em'
      }
    },
    '& button:focus': {
      backgroundColor: apStatus?.color || colors.lightGray,
      borderColor: apStatus?.color || colors.lightGray,
      color: apStatus?.color ? colors.white : colors.black
    },
    '& .status-icon': {
      marginRight: '0.5rem',
      marginTop: '-0.25rem',
    }
  },
  '& .buttonFromAppoint': {
    '& button': {
      padding: "5px !important"
    }
  }
}))
const ImageDelete = styled(Image)(({ theme }) => ({ opacity: 1, '&:hover': { opacity: 1 } }))

/** INTERFACE */
export interface FormAppointmentProps {
  typeForm?: string
  showForm: boolean
  appointmentId?: number
  branchId?: number
  date?: any
  dataAppointment?: any
  editSpecialInfo: boolean | false
  handleSuccess?: (Date?: any) => void
  reload?: () => void
  onReset?: () => void
  onDelete?: (id: number, obj?: any) => void
  officeTime: {
    branchId: number
    dayOfWeek: string
    officeStatus: "OPEN" | "CLOSE"
    timeIn: string
    timeOut: string
  }[]
  handleDate?: (val: any) => void
  handleBranch?: (val: any) => void
  viewDisplay?: any
  reRender?: (data: any) => void
  setRerender?: (value: boolean) => void
  reRenderValue?: boolean
  patientIdApp?: any
  timeAppointment?: TIME_APPOINTMENT | undefined
  doctorId?: number
}

/** VARIABLE */
const initStateErrorMessage = {
  DATE_STRING_EMPTY: '',
  DATE_ANY_REQUIRED: '',
  PATIENT_ANY_REQUIRED: '',
  PHONE_STRING_EMPTY: '',
  PATIENT_NAME_STRING_EMPTY: '',
  PATIENT_LASTNAME_STRING_EMPTY: '',
  PATIENT_PHONE_STRING_EMPTY: '',

  BRANCH_ANY_REQUIRED: '',
  DOCTOR_ANY_REQUIRED: '',
  TIME_START_ANY_REQUIRED: '',
  DURATION_MINUTE_ANY_REQUIRED: '',
  REMARK_CANCEL_STRING_EMPTY: '',
  REMARK_CANCEL_ANY_REQUIRED: '',
  APPOINTMENT_OPERATIVES_ANY_REQUIRED: '',

  // SPACIAL_INFO_REQUIRED: '',
  PRICE_REQUIRED: '',
  PRACTICE_REQUIRED: '',
  REMARK_REQUIRED: ''

}

export function FormAppointment(props: FormAppointmentProps) {
  const { t, i18n } = useTranslation()
  const history = useHistory()
  const dispatch = useDispatch()
  const location = useLocation()
  const permissions = {
    isDelete: isDelete(),
  }

  const isSubmit = useSelector((state: any) => state.modal.isSubmit)
  const formAppointments = useSelector(formAppointment)
  const isEditMode = Boolean(props.appointmentId);
  const [loading, setLoading] = useState<boolean>(false)

  const [newPatient, setNewPatient] = useState<boolean>(false)
  const [isEdit, setIsEdit] = useState<boolean>(false)
  const [labelStatus, setLabelStatus] = useState<any>('')
  const [errorMessage, setErrorMessage] = useState({ ...initStateErrorMessage })

  /** LIST DATA */
  const [patients, setPatients] = useState([])
  const [branches, setBranches] = useState([])
  const [dentists, setDentists] = useState<DentistsInterface[]>([])
  const [durationMinutes, setDurationMinutes] = useState([])
  const [operativeTypes, setOperativeTypes] = useState<TreatmentItemsInterface[]>([])

  /** FILED */
  const [date, setDate] = useState<string>(props.date ? moment(`${props.date.year}-${String(props.date.month).padStart(2, '0')}-${String(props.date.date).padStart(2, '0')}`, 'YYYY-MM-DD').format('YYYY-MM-DD') : moment().format('YYYY-MM-DD') || '')
  const [patient, setPatient] = useState<any>(null)
  const [patientId, setPatientId] = useState<number>()
  const [patientFirstname, setPatientFirstname] = useState<string>('')
  const [patientLastname, setPatientLastname] = useState<string>('')
  const [patientPhone, setPatientPhone] = useState<string>('')
  const [phone, setPhone] = useState<string>('')
  const [branchId, setBranchId] = useState<number>(props.branchId || getBranch())
  const [doctorId, setDoctorId] = useState<number>()
  const [timeStart, setTimeStart] = useState<string>()
  const [durationMinute, setDurationMinute] = useState<number>()
  const [operativeType, setOperativeType] = useState<TreatmentItemsInterface[]>([])
  const [price, setPrice] = useState<any>('0')
  const [lab, setLab] = useState<boolean>(false)
  const [xray, setXray] = useState<boolean>(false)
  const [practice, setPractice] = useState<any[]>([])
  const [status, setStatus] = useState<string>('NORMAL')
  const [remark, setRemark] = useState<any[]>([])
  const [remarkCancel, setRemarkCancel] = useState<string>('')
  const [objAppontment, setObjAppontment] = useState<any>({})
  const [specialInfo, setSpecialInfo] = useState<string>('')
  const [officeTimeByDay, setOfficeTimeByDay] = useState<{ officeStatus?: "OPEN" | "CLOSE", timeIn?: string, timeOut?: string }>({});

  const [appRemark, setAppRemark] = useState<string[]>([''])
  const [isEditApp, setIsEditApp] = useState<boolean>(false)

  const showEdit: boolean = (props.appointmentId ? objAppontment?.appointmentId === props.appointmentId : true) || false

  /**config */
  const [showTemplateText, setShowTemplateText] = useState<boolean>(false)
  const [typeText, setTypeText] = useState<string>('')
  const [disabled, setDisabled] = useState<boolean>(props.editSpecialInfo || false)

  const [width] = useWindowSize()

  const [inputSpecialInfo, setInputSpecialInfo] = useState<boolean>(false)
  const [specialInfoClone, setSpecialInfoClone] = useState<string>('')

  const [treatmentItemsPage, setTreatmentItemsPage] = useState<number>(1)
  const [treatmentItemsSearch, setTreatmentItemsSearch] = useState<number>(1)
  const [newTreatmentItems, setNewTreatmentItems] = useState<any>([])
  const [countCurrentTI, setCountCurrentTI] = useState<number[]>([0])
  const [countTreatmentItems, setCountTreatmentItems] = useState<number>(0)
  const [contentMaxTI, setContentMaxTI] = useState<number>(0)
  const treatmentItemsRef = useRef<any>(null)

  const [isOpenSnack, setIsOpenSnack] = useState(false)
  const [typeSnack, setTypeSnack] = useState<any>("success")
  const [labelSnack, setLabelSnack] = useState('')
  const [configAlert, setConfigAlert] = useState<ConfigAlert>(initialConfigAlert)
  const [isLabOrderModalOpen, setIsLabOrderModalOpen] = useState(false);
  const [labOrdersList, setLabOrdersList] = useState<any[]>([]);
  const [loadingLabOrders, setLoadingLabOrders] = useState<boolean>(false);
  const [selectedLabOrders, setSelectedLabOrders] = useState<any[]>([]);
  const [stampSelectedLabOrders, setStampSelectedLabOrders] = useState<any[]>([]);

  const [page, setPage] = useState(1)
  const [pageLimit, setPageLimit] = useState(5)
  const [searchLab, setSearchLab] = useState('')
  const [hasMoreLabOrders, setHasMoreLabOrders] = useState(true);
  const [pageTotal, setPageTotal] = useState(0)
  const [height, setHeight] = useState(300);

  /** VARIABLE */
  const statusIcon: any = {
    normal: { src: icons.appointment.normal, color: colors.appointmentStatus.statusNormal, label: t('APPOINTMENT.STATUS.NORMAL'), disabled: false },
    cancel: { src: cancel, color: colors.appointmentStatus.statusCancel, label: t('APPOINTMENT.STATUS.CANCEL'), disabled: false },
    unconnect: { src: notConnect, color: colors.appointmentStatus.statusUnConnect, label: t('APPOINTMENT.STATUS.CAN_NOT_CONTACT'), disabled: false },
    change: { src: changeSchedule, color: colors.appointmentStatus.statusChange, label: t('APPOINTMENT.STATUS.PUT_OFF'), disabled: false },
    enter: { src: enter, color: colors.appointmentStatus.statusEnter, label: t('APPOINTMENT.STATUS.CONFIRM'), disabled: false },

    arrived: { src: userCheckTrue, color: colors.appointmentStatus.statusArrived, label: t('APPOINTMENT.STATUS.ARRIVED'), disabled: true },
    unarrived: { src: userCheckFalse, color: colors.appointmentStatus.statusUnArrived, label: t('APPOINTMENT.STATUS.NOT_YET'), disabled: true },
    cancel_app: { src: icons.appointment.cancel_app, color: colors.appointmentStatus.statusCancel, label: t('APPOINTMENT.STATUS.CANCEL_APP'), disabled: true },
    payment: { src: icons.appointment.iconPendingPayment, color: colors.appointmentStatus.statusWaitPayment, label: t('APPOINTMENT.STATUS.PAYMENT'), disabled: true },
    pendingPayment: { src: icons.appointment.iconWaitPayment, color: colors.appointmentStatus.statusPayment, label: t('APPOINTMENT.STATUS.PENDING_PAYMENT'), disabled: true },
    pendingService: { src: icons.appointment.iconCounterCheckIn, color: colors.appointmentStatus.statusCounterCheckIn, label: t('APPOINTMENT.STATUS.PENDING_SERVICE'), disabled: true },
    service: { src: icons.appointment.iconService, color: colors.appointmentStatus.statusService, label: t('APPOINTMENT.STATUS.SERVICE'), disabled: true },
    done: { src: ThemeIcon.DoneTreatment, color: colors.appointmentStatus.statusDone, label: t('APPOINTMENT.STATUS.DONE'), disabled: true },
  }

  const loadData = () => {
    if (!branches.length) ClinicApi.findAllActiveBranches().then(({ data }) => data && setBranches(data))
    // if (!dentists.length) DoctorScheduleApi.doctorsOnDay({ branchId, date }).then(({ data }) => data && setDentists(data))
    if (!durationMinutes.length) AppointmentDurationApi.findAll({ status: 'ACTIVE', pageLimit: 80, sortBy: 'durationMinute' }).then(({ data }) => data && setDurationMinutes(data))
  }

  const loadDataTreatmentItems = useCallback(async (search = '', nextPage?: boolean) => {
    const page = nextPage ? (treatmentItemsPage + 1) : 1

    setTreatmentItemsPage(page)
    setTreatmentItemsSearch(search)
    const condition = { search: search, page: page, pageLimit: 30 }
    await ComponentApi.findAllTreatmentItems(condition).then((res) => {
      setCountTreatmentItems(Number(res?.headers['x-total']) || 0)
      if (page === 1) {
        setCountCurrentTI([res?.data?.length || 0])
        setNewTreatmentItems([])
        res?.data && setOperativeTypes(res.data)
      } else {
        setCountCurrentTI([...countCurrentTI, res?.data?.length || 0])
        setNewTreatmentItems([...newTreatmentItems, ...res?.data])
      }
    })
  }, [treatmentItemsPage, treatmentItemsSearch, newTreatmentItems])

  useEffect(() => {
    if (treatmentItemsRef && treatmentItemsRef.current) {
      treatmentItemsRef.current.scrollTop = contentMaxTI - 385;
    }
  }, [newTreatmentItems])

  const handleLengthOperative = () => {
    const newCount = countCurrentTI.reduce((a, b) => a + b, 0,)
    return newCount < countTreatmentItems
  }


  const handleCancelLabOrder = (labOrderId: number) => {
    setSelectedLabOrders(prev => prev.filter(order => order.labOrderId !== labOrderId));
  };


  const fetchLabOrders = async (isLoadMore = false, resetPage = false) => {

    if (!patientId) return;
    setLoadingLabOrders(true);

    const currentPage = resetPage ? 1 : (isLoadMore ? page + 1 : 1);

    try {
      let condition: any = {}
      if (patientId) condition = { ...condition, patientId: patientId }
      if (branchId) condition = { ...condition, branchId: branchId }
      condition = { ...condition, page: currentPage }
      if (pageLimit) condition = { ...condition, pageLimit: pageLimit }
      if (date) condition = { ...condition, appointmentDate: date }
      if (searchLab) condition = { ...condition, search: searchLab }

      const resp = await AppointmentApi.findLabOrdersAllByPatientId(condition);
      if (resetPage) {
        setLabOrdersList(resp.data);
      } else if (isLoadMore) {
        setLabOrdersList(prevOrders => [...prevOrders, ...resp.data]);
      } else {
        setLabOrdersList(resp.data);
      }

      setPageTotal(resp.headers['x-total'])
      setPage(currentPage);
      if (resp.data.length < pageLimit) {
        setHasMoreLabOrders(false);
      } else {
        setHasMoreLabOrders(true);
      }
    } catch (error) {
      console.error("Error fetching lab orders:", error);
      setLabOrdersList([]);
    } finally {
      setLoadingLabOrders(false);
    }
  };


  const handleLoadMoreLabOrders = () => {
    if (hasMoreLabOrders && !loadingLabOrders) {
      fetchLabOrders(true);
    }
  };


  useEffect(() => {
    loadDataTreatmentItems()
  }, [])

  useEffect(() => {
    if (isLabOrderModalOpen && patientId) {
      fetchLabOrders(false, true);
    }
  }, [isLabOrderModalOpen, patientId]);


  useEffect(() => {
    setDisabled(props.editSpecialInfo)
  }, [props.editSpecialInfo])

  const loadPatients = (search = '', patientId = 0) => {
    ClinicApi.findAllPatients({ pageLimit: 50, allBranch: true, condition: 'branchCnNumber', patientId: patientId, appointment: true }).then(({ data }) => {
      if (data) {
        setPatients(data)
        if (patientId) {
          const patientData: any = data.find((pa: any) => pa.patientId === patientId)
          setPatient(patientData)
          setPatientId(patientId || patientData?.patientId)
          setPhone(patientData?.phone || '')
          setSpecialInfo(patientData?.specialInfo || '')
        }
      }
    })
  }


  useEffect(() => {
    // setDoctorId(0)
    setDoctorId(props.doctorId ?? doctorId)
    setBranchId(props.branchId || branchId)
    setDate(props.date ? moment(`${props.date.year}-${String(props.date.month).padStart(2, '0')}-${String(props.date.date).padStart(2, '0')}`, 'YYYY-MM-DD').format('YYYY-MM-DD') : date)
  }, [props.branchId, props.date])


  useEffect(() => {
    loadData()
    const patientState: any = location.state
    if (patientState?.patientId) {
      loadPatients(patientState.firstname, patientState.patientId)
      history.replace({ ...history.location, state: undefined })
    }
    if (!props.showForm)
      history.replace({ ...history.location, state: undefined })
  }, [props.showForm])

  const handleEdit = (ap: AppointmentInterface) => {
    setDate(ap.date)
    setPatient(patients.find((pa: any) => pa.patientId === ap.patientId))
    setPatientId(ap.patientId)
    setPatientFirstname('')
    setPatientLastname('')
    setPatientPhone('')
    setPhone(ap.phone)
    setSpecialInfo(ap.specialInfo)
    setBranchId(ap.branchId)
    setDoctorId(ap.doctorId)
    const time = ap.timeStart.substring(0, ap.timeStart.length - 3)
    setTimeStart(time)
    setDurationMinute(ap.durationMinute)
    setSelectedLabOrders([...ap.appointmentLabs])
    const temp: any = ap.appointmentOperatives?.map((apOperativeType: any) => {
      return {
        color: apOperativeType.color,
        operativeId: apOperativeType.operativeId,
        operativeName: apOperativeType.operativeName,
        operativeNameEn: apOperativeType.operativeNameEn,
        operativeTypeId: apOperativeType.operativeTypeId,
        operativeTypeName: apOperativeType.operativeTypeName,
        operativeTypeNameEn: apOperativeType.operativeTypeNameEn,
      }
    })
    setOperativeType(temp)
    setPrice(ap.price || 0)
    setLab(ap.hasLab === 'HAS' ? true : false)
    setXray(ap.hasXray === 'HAS' ? true : false)
    setPractice([ap.practice])
    setStatus(ap.statusAppointment)
    setRemark([ap.remark])
    setRemarkCancel(ap.remarkCancel)
    setAppRemark([ap?.applicationDetail || ""])

    if (ap?.isApplication === "1") {
      setIsEditApp(true)
    }

    if (!ap.branchCnNumber && !ap.cnNumber) {

      setNewPatient(true)
      const newName = ap.patientFullname.split(' ')
      setPatientFirstname(ap?.firstname || newName[0])
      setPatientLastname(ap?.lastname || newName[1])
      setPatientPhone(ap.phone)
    }

    if (ap.statusAppointment === 'CANCEL') setLabelStatus('cancel')
    else if (ap.statusAppointment === 'ARRIVED') setLabelStatus('arrived')
    else if (ap.statusAppointment === 'CAN_NOT_CONTACT') setLabelStatus('unconnect')
    else if (ap.statusAppointment === 'PUT_OFF') setLabelStatus('change')
    else if (ap.statusAppointment === 'CONFIRM') setLabelStatus('enter')
    else if (ap.statusAppointment === 'NOT_YET') setLabelStatus('unarrived')
    else if (ap.statusAppointment === 'PENDING_PAYMENT') setLabelStatus('pendingPayment')
    else if (ap.statusAppointment === 'PAYMENT') setLabelStatus('payment')
    else if (ap.statusAppointment === 'PENDING_SERVICE') setLabelStatus('pendingService')
    else if (ap.statusAppointment === 'SERVICE') setLabelStatus('service')
    else if (ap.statusAppointment === 'DONE') setLabelStatus('done')
    else setLabelStatus(undefined)
    setIsEdit(true)
  }

  useEffect(() => {
    const fetchData = async () => {
      if (props.appointmentId) {
        try {
          const ap: any = await AppointmentApi.findById(props.appointmentId);
          if (ap.status === 200) {
            const data = ap.data;
            handleEdit(data);
            loadPatients(data.patientFullname, data.patientId);
            setObjAppontment(data)
          }
        } catch (error) {
          console.error("Error loading appointment data:", error);
        }
      }
    };

    if (props?.patientIdApp?.patientId) {
      handlePatientIdApp()
    } else {
      fetchData();
    }
  }, [props.appointmentId, props?.patientIdApp]);


  useEffect(() => {
    // ถ้ามี appointmentId แต่ยังไม่ได้ load appointment data ให้รอก่อน
    if (props.appointmentId && !objAppontment?.appointmentId) {
      return
    }
    DoctorScheduleApi.doctorsOnDay({ branchId, date }).then(({ data }) => data && setDentists(data))
  }, [branchId, date, props.appointmentId, objAppontment?.appointmentId])

  /** FUNCTION */
  const clearErrorMessage = () => setErrorMessage(initStateErrorMessage)

  const resetForm = () => {
    clearErrorMessage()
    handleNewPatient(false)
    setDate(moment().format('YYYY-MM-DD'))
    setPatient(null)
    setPatientId(0)
    setPatientFirstname('')
    setPatientLastname('')
    setPatientPhone('')
    setPhone('')
    setBranchId(getBranch())
    setDoctorId(0)
    setTimeStart(undefined)
    setDurationMinute(0)
    setOperativeType([])
    setPrice(0)
    setLab(false)
    setXray(false)
    setPractice([])
    setStatus('NORMAL')
    setRemark([])
    setRemarkCancel('')
    setLabelStatus(undefined)
    setDisabled(false)
    setAppRemark([])
    setIsEditApp(false)
    if (props.onReset) props.onReset()
    setIsEdit(false)
  }

  useEffect(() => {
    clearErrorMessage()
  }, [date, patientId, phone, newPatient, patientFirstname, patientLastname, patientPhone, branchId, doctorId, timeStart, durationMinute, operativeType, remarkCancel])

  const setNum_isDupicate = (data: any) => {
    if (data === undefined) {
      return 0
    }
    if (props.appointmentId === undefined) {
      const check_data = data.filter((item: any) => item.statusAppointment !== "CANCEL" && item.statusAppointment !== "PUT_OFF");
      return check_data.length
    } else {
      const Del_appointmentId = _.reject(data, { appointmentId: props.appointmentId });
      const check_data = Del_appointmentId.filter((item: any) => item.statusAppointment !== "CANCEL" && item.statusAppointment !== "PUT_OFF");
      return check_data.length
    }
  }

  const check_isDupicate = (dataAppointment: any) => {
    if (status === "CANCEL" || dataAppointment === undefined) {
      return 0
    }
    const time = typeof timeStart !== "undefined" ? timeStart.slice(0, 5) : ''
    const data = _.filter(dataAppointment, { doctorId: doctorId })[0]?.groupAppointments[time]
    return setNum_isDupicate(data)
  }

  const handleCheckReq = () => {
    if (!formAppointments?.length || !Object.values(formAppointments).length) {
      return {}
    }
    const newDataCheckReq: any = {}
    formAppointments.forEach((item: any) => {
      if (item.id === 'price' && isEditMode && Number(price) === 0) return;
      if (!item.isDisabled && item.isRequired) {
        if (item.id === 'spacialInfo' && (inputSpecialInfo ? specialInfoClone : specialInfo) === "" ||
          item.id === 'price' && !price ||
          item.id === 'prictice' && valInputTextArea(practice.toString()) === '' ||
          item.id === 'note' && valInputTextArea(remark.toString()) === '') {
          if (item.text !== 'SPACIAL_INFO') {
            newDataCheckReq[`${item.text}_REQUIRED`] = t(`APPOINTMENT.MESSAGE.${item.text}_REQUIRED`)
          }
        }
      }
    })
    return newDataCheckReq
  }

  useEffect(() => {
    if (props?.patientIdApp?.patientId) return
    if (dentists.length > 0 && doctorId) {
      const isDoctorAvailable = dentists.some((dentist) => dentist.doctorId === doctorId);
      if (!isDoctorAvailable) {
        setDoctorId(0);
        setTimeStart('');
        //  setDurationMinute(0);
        notiError('หมอไม่มีเวร/ไม่เข้าเวรในวันนั้น')
      }
    }
  }, [dentists]);

  const handleSubmit = async () => {
    clearErrorMessage()
    setLoading(true)

    const dataError = handleCheckReq()

    if (!date || (newPatient ? !patientFirstname || !patientLastname || !patientPhone : !patient || !phone) || !branchId || !doctorId || !timeStart || !durationMinute || !operativeType.length || (status === 'CANCEL' && !remarkCancel) || Object.values(dataError).length) {
      const msg: any = {
        DATE_STRING_EMPTY: !date ? t(`APPOINTMENT.MESSAGE.DATE_STRING_EMPTY`) : '',
        DATE_ANY_REQUIRED: !date ? t(`APPOINTMENT.MESSAGE.DATE_ANY_REQUIRED`) : '',
        PATIENT_ANY_REQUIRED: !patient && !newPatient ? t(`APPOINTMENT.MESSAGE.PATIENT_ANY_REQUIRED`) : '',
        PHONE_STRING_EMPTY: !phone && !newPatient ? t(`APPOINTMENT.MESSAGE.PHONE_STRING_EMPTY`) : '',
        PATIENT_NAME_STRING_EMPTY: !patientFirstname && newPatient ? t(`APPOINTMENT.MESSAGE.PATIENT_NAME_STRING_EMPTY`) : '',
        PATIENT_LASTNAME_STRING_EMPTY: !patientLastname && newPatient ? t(`APPOINTMENT.MESSAGE.PATIENT_LASTNAME_STRING_EMPTY`) : '',
        PATIENT_PHONE_STRING_EMPTY: !patientPhone && newPatient ? t(`APPOINTMENT.MESSAGE.PATIENT_PHONE_STRING_EMPTY`) : '',
        BRANCH_ANY_REQUIRED: !branchId ? t(`APPOINTMENT.MESSAGE.BRANCH_ANY_REQUIRED`) : '',
        DOCTOR_ANY_REQUIRED: !doctorId ? t(`APPOINTMENT.MESSAGE.DOCTOR_ANY_REQUIRED`) : '',
        TIME_START_ANY_REQUIRED: !timeStart ? t(`APPOINTMENT.MESSAGE.TIME_START_ANY_REQUIRED`) : '',
        DURATION_MINUTE_ANY_REQUIRED: !durationMinute ? t(`APPOINTMENT.MESSAGE.DURATION_MINUTE_ANY_REQUIRED`) : '',
        REMARK_CANCEL_STRING_EMPTY: status === 'CANCEL' || !remarkCancel ? t(`APPOINTMENT.MESSAGE.REMARK_CANCEL_STRING_EMPTY`) : '',
        REMARK_CANCEL_ANY_REQUIRED: status === 'CANCEL' || !remarkCancel ? t(`APPOINTMENT.MESSAGE.REMARK_CANCEL_ANY_REQUIRED`) : '',
        APPOINTMENT_OPERATIVES_ANY_REQUIRED: !operativeType.length ? t(`APPOINTMENT.MESSAGE.APPOINTMENT_OPERATIVES_ANY_REQUIRED`) : ''
      }
      setErrorMessage({ ...initStateErrorMessage, ...msg, ...dataError })
      setLoading(false)
      return false
    }


    const objSend: any = {
      branchId,
      patientId,
      phone,
      date,
      timeStart,
      durationMinute,
      doctorId,
      practice: practice.toString(),
      price,
      hasLab: lab ? 'HAS' : 'NOT_HAS',
      hasXray: xray ? 'HAS' : 'NOT_HAS',
      statusAppointment: status,
      remark: remark.toString(),
      remarkCancel,
      specialInfo: inputSpecialInfo ? specialInfoClone : specialInfo,
      appointmentOperatives: operativeType.map((op: any) => {
        const send: any = {
          operativeTypeId: op.operativeTypeId,
          color: op.color
        }
        if (op.operativeId) send.operativeId = op.operativeId
        return send
      }),
      applicationDetail: appRemark.toString()
    }

    const validateAppointment: ValidateAppointmentInterface = {
      date: objSend.date,
      timeStart: objSend.timeStart,
      branchId: objSend.branchId,
      doctorId: objSend.doctorId,
      durationMinute: objSend.durationMinute
    }
    if (props?.appointmentId) validateAppointment.appointmentId = props?.appointmentId

    let condition: any = {}
    condition = { ...condition, branchId: branchId }
    condition = { ...condition, date: date }
    condition = { ...condition, doctorId: String(doctorId) }
    let dataAppointment: any = {}
    await AppointmentApi.displayDay(condition).then(({ data }) => {
      if (data) {
        dataAppointment = data
      }
    })
    await AppointmentApi.validateAppointment(validateAppointment)
      .then(({ data }) => {
        const { appointment, officeTime, schedule, breakTime } = data
        setLoading(false)

        const hasDup = check_isDupicate(dataAppointment) !== 0
        const hasOutSched = schedule?.isOutOfTime
        const hasOutOffice = !schedule?.isOutOfTime && officeTime?.isOutOfTimeOffice
        const hasBreak = breakTime?.isBreakTime

        if (hasDup || hasOutSched || hasOutOffice || hasBreak) {
          const labels = {
            dup: t('APPOINTMENT.MESSAGE.DUP_APPOINTMENT'),
            outSched: t('APPOINTMENT.MESSAGE.OUT_WORK_APPOINTMENT'),
            outOffice: t('APPOINTMENT.MESSAGE.OUT_TIME_APPOINTMENT'),
            break: t('APPOINTMENT.MESSAGE.BREAK_APPOINTMENT')
          }
          const issues: string[] = []
          if (hasDup) issues.push(labels.dup)
          if (hasOutSched) issues.push(labels.outSched)
          if (hasOutOffice) issues.push(labels.outOffice)
          if (hasBreak) issues.push(labels.break)

          const message = `${t('VALIDATION.ALERT.CONTENT', { content: `${issues.join(t('AND'))}` })}`
          const children: React.ReactNode[] = [
            hasDup && (
              <Box key="dup" sx={{ display: 'flex', alignItems: 'flex-start', pt: 1, maxWidth: 450, flexDirection: 'column' }} >
                <Box display="flex" flexDirection="row">
                  <Box sx={{ pr: 2, pb: 1 }}><CancelRoundedIcon sx={{ color: '#FB5252' }} /></Box>
                  <Box><Typography component="span" sx={{ pr: 2, fontWeight: 500, color: colors.textPrimary, fontSize: '14px' }}>
                    {t('APPOINTMENT.MESSAGE.DUP_APPOINTMENT')}</Typography>
                  </Box>
                </Box>
                <Box>
                  <Typography sx={{ fontSize: '14px' }}>
                    {`${t('APPOINTMENT.POPUP.WARNING.IS_DAY')} ${toBuddhistYear(moment(objSend.date), 'DD/MM/YYYY')}
                ${appointment.doctor?.prefix || ''}${appointment.doctor?.firstname || ''} ${appointment.doctor?.lastname || ''}
                ${t('APPOINTMENT.POPUP.WARNING.APPOINTMENT')} ${moment(objSend.timeStart, 'HH:mm').format('HH.mm')}
                ${t('APPOINTMENT.POPUP.WARNING.TIME')} ${t('APPOINTMENT.POPUP.WARNING.COUNT_PATIENT')}
                ${check_isDupicate(dataAppointment)} ${t('APPOINTMENT.POPUP.WARNING.NUM_USER')}`}
                  </Typography>
                </Box>
              </Box>
            ),
            hasOutSched && (
              <Box key="sched" sx={{ display: 'flex', alignItems: 'flex-start', pt: 1, maxWidth: 450, flexDirection: 'column' }} >
                <Box display="flex" flexDirection="row">
                  <Box sx={{ pr: 2, pb: 1 }}><CancelRoundedIcon sx={{ color: '#FB5252' }} /></Box>
                  <Box><Typography component="span" sx={{ pr: 2, fontWeight: 500, color: colors.textPrimary, fontSize: '14px' }}>
                    {t('APPOINTMENT.MESSAGE.OUT_WORK_APPOINTMENT')}</Typography>
                  </Box>
                </Box>
                <Box>
                  <Typography sx={{ fontSize: '14px' }}>
                    {`${t('APPOINTMENT.POPUP.WARNING.IS_DAY')} ${toBuddhistYear(moment(objSend.date), 'DD/MM/YYYY')}
                ${schedule.doctor?.prefix || ''}${schedule.doctor?.firstname || ''} ${schedule.doctor?.lastname || ''}
                ${t('APPOINTMENT.POPUP.WARNING.TIME_WORK')}
                ${moment(schedule.timeStart || '00:00', 'HH:mm').format('HH.mm น.')} - 
                ${moment(schedule.timeEnd || '00:00', 'HH:mm').format('HH.mm น.')}
                ${t('APPOINTMENT.POPUP.WARNING.OUT_WORK')} ${moment(objSend.timeStart, 'HH:mm').format('HH.mm')}
                ${t('APPOINTMENT.POPUP.WARNING.TIME')}`}
                  </Typography>
                </Box>
              </Box>
            ),
            hasOutOffice && (
              <Box key="office" sx={{ display: 'flex', alignItems: 'flex-start', pt: 1, maxWidth: 450, flexDirection: 'column' }} >
                <Box display="flex" flexDirection="row">
                  <Box sx={{ pr: 2, pb: 1 }}><CancelRoundedIcon sx={{ color: '#FB5252' }} /></Box>
                  <Box><Typography component="span" sx={{ pr: 2, fontWeight: 500, color: colors.textPrimary, fontSize: '14px' }}>
                    {t('APPOINTMENT.MESSAGE.OUT_TIME_APPOINTMENT')}</Typography>
                  </Box>
                </Box>
                <Box>
                  <Typography sx={{ fontSize: '14px' }}>
                    {`${t('APPOINTMENT.POPUP.WARNING.IS_DAY')} ${toBuddhistYear(moment(objSend.date), 'DD/MM/YYYY')}
                ${officeTime.doctor?.prefix || ''}${officeTime.doctor?.firstname || ''} ${officeTime.doctor?.lastname || ''}
                ${t('APPOINTMENT.POPUP.WARNING.TIME_WORK')}
                ${moment(officeTime.timeIn || '00:00', 'HH:mm').format('HH.mm น.')} - 
                ${moment(officeTime.timeOut || '00:00', 'HH:mm').format('HH.mm น.')}
                ${t('APPOINTMENT.POPUP.WARNING.OUT_WORK')} ${moment(objSend.timeStart, 'HH:mm').format('HH.mm')}
                ${t('APPOINTMENT.POPUP.WARNING.TIME')}`}
                  </Typography>
                </Box>
              </Box>
            ),
            hasBreak && (
              <Box key="break" sx={{ display: 'flex', alignItems: 'flex-start', pt: 1, maxWidth: 450, flexDirection: 'column' }} >
                <Box display="flex" flexDirection="row">
                  <Box sx={{ pr: 2, pb: 1 }}><CancelRoundedIcon sx={{ color: '#FB5252' }} /></Box>
                  <Box><Typography component="span" sx={{ pr: 2, fontWeight: 500, color: colors.textPrimary, fontSize: '14px' }}>
                    {t('APPOINTMENT.MESSAGE.BREAK_APPOINTMENT')}</Typography>
                  </Box>
                </Box>
                <Box>
                  <Typography component="span" sx={{ fontSize: '14px' }}>
                    {`${t('APPOINTMENT.POPUP.WARNING.IS_DAY')} ${toBuddhistYear(moment(objSend.date), 'DD/MM/YYYY')}
                ${breakTime.doctor?.prefix || ''}${breakTime.doctor?.firstname || ''} ${breakTime.doctor?.lastname || ''}
                ${t('APPOINTMENT.POPUP.WARNING.TIME_BRAKE')}
                ${moment(breakTime.breakTimeStart || '00:00', 'HH:mm').format('HH.mm น.')} - 
                ${moment(breakTime.breakTimeEnd || '00:00', 'HH:mm').format('HH.mm น.')}
                ${t('APPOINTMENT.POPUP.WARNING.OUT_BRAKE')} ${moment(objSend.timeStart, 'HH:mm').format('HH.mm')}
                ${t('APPOINTMENT.POPUP.WARNING.TIME')}`}
                  </Typography>
                </Box>
              </Box>
            )
          ].filter(Boolean)
          setConfigAlert({
            isOpen: true,
            title: t('VALIDATION.ALERT.CONTINUE'),
            message,
            type: 'warning',
            children,
            onCancel: { onClick: () => setConfigAlert(initialConfigAlert), title: t('BUTTON.CANCEL') },
            onSubmit: {
              onClick: () => {
                onSubmitAppointment(objSend, isEdit)
                setConfigAlert(initialConfigAlert)
              }, title: t('BUTTON.SUBMIT')
            },
            handleClose: () => setConfigAlert(initialConfigAlert)
          })

          return
        }
        onSubmitAppointment(objSend, isEdit)
      })
  }

  const onSubmitAppointment = (objSend: any, statusEdit: boolean) => {
    if (newPatient) objSend.newPatient = { firstname: patientFirstname, lastname: patientLastname, phone: patientPhone }
    if (!statusEdit) {
      create(objSend)
    } else if (disabled) {
      objSend.status = 'ACTIVE'
      update(objSend)
    } else {
      objSend.status = 'ACTIVE'
      update(objSend)
    }
  }
  const create = (payload: any) => {
    setLoading(true)
    let objDate: any = {}
    if (props.handleDate) {
      objDate = {
        year: moment(payload.date)?.year(),
        month: (moment(payload.date)?.month()) + 1,
        date: moment(payload.date)?.date(),
        day: props.viewDisplay === 'DATE' ? moment(payload.date).format('ddd') : (String(moment(payload.date)?.format('ddd')) || String(moment()?.format('ddd'))),
        display: props.viewDisplay
      }
    }
    const appointmentLabs: any = []
    if (selectedLabOrders.length > 0) {
      selectedLabOrders.map((e: any) => {
        appointmentLabs.push(e.labOrderId)
      })
    }

    AppointmentApi.create({ ...payload, appointmentLabs })
      .then((res: any) => {
        if (res.status !== undefined && res.status === 201) {
          if (props?.handleSuccess) props?.handleSuccess(objDate)
          dispatch(resetModal())
          resetForm()
          notiSuccess(t(`APPOINTMENT.MESSAGE.SUCCESS.CREATE`), '', null)
        } else {
          const err = res.response.data
          setErrorMessage({ ...initStateErrorMessage, [err.message]: t(`APPOINTMENT.MESSAGE.${err.message}`) })
        }
      })
      .catch((e) => {
        const err = e.response.data
        notiError(t(`APPOINTMENT.MESSAGE.${err.message}`))

      })
      .finally(() => {
        setLoading(false)
        if (props?.reRender) {
          props.reRender(payload)
        }
      })
  }

  const update = (payload: any) => {
    setLoading(true)
    let objDate: any = {}
    if (props.handleDate) {
      objDate = {
        year: moment(payload.date)?.year(),
        month: (moment(payload.date)?.month()) + 1,
        date: moment(payload.date)?.date(),
        day: props.viewDisplay === 'DATE' ? moment(payload.date).format('ddd') : (String(moment(payload.date)?.format('ddd')) || String(moment()?.format('ddd'))),
        display: props.viewDisplay
      }
    }
    if (payload?.newPatient?.phone && !payload?.phone) {
      payload.phone = payload.newPatient.phone
    }

    const appointmentLabs: any = []
    if (selectedLabOrders.length > 0) {
      selectedLabOrders.map((e: any) => {
        appointmentLabs.push(e.labOrderId)
      })
    }
    AppointmentApi.update(Number(props.appointmentId), { ...payload, appointmentLabs })
      .then((res: any) => {
        if (res.status !== undefined && res.status === 200) {
          if (props?.handleSuccess) props?.handleSuccess(objDate)
          dispatch(resetModal())
          resetForm()
          notiSuccess(t(`APPOINTMENT.MESSAGE.SUCCESS.UPDATED`), '', null)
        } else {
          const err = res.response?.data
          notiError(t(`APPOINTMENT.MESSAGE.${err.message}`))

        }
      })
      .catch((e) => {
        const err = e.response.data
        notiError(t(`APPOINTMENT.MESSAGE.${err.message}`))

      })
      .finally(() => {
        setLoading(false)
        if (props?.reRender) {
          props.reRender(payload)
        }
      })
  }

  const handleStatus = (appointmentStatus: any) => {
    setLabelStatus(appointmentStatus)
    if (appointmentStatus === 'cancel') setStatus('CANCEL')
    else if (appointmentStatus === 'normal') setStatus('NORMAL')
    else if (appointmentStatus === 'arrived') setStatus('ARRIVED')
    else if (appointmentStatus === 'unconnect') setStatus('CAN_NOT_CONTACT')
    else if (appointmentStatus === 'change') setStatus('PUT_OFF')
    else if (appointmentStatus === 'enter') setStatus('CONFIRM')
    else if (appointmentStatus === 'unarrived') setStatus('NOT_YET')
    else if (appointmentStatus === 'pendingPayment') setStatus('PENDING_PAYMENT')
    else if (appointmentStatus === 'payment') setStatus('PAYMENT')
    else if (appointmentStatus === 'pendingService') setStatus('PENDING_SERVICE')
    else if (appointmentStatus === 'service') setStatus('SERVICE')
    else if (appointmentStatus === 'done') setStatus('DONE')
    else if (appointmentStatus === 'pushOff') setStatus('PUT_OFF')
    else setStatus('')
  }

  const renderStatus = (appointmentStatus: any) => {
    if (appointmentStatus === 'cancel') return 'CANCEL'
    else if (appointmentStatus === 'normal') return 'NORMAL'
    else if (appointmentStatus === 'arrived') return 'ARRIVED'
    else if (appointmentStatus === 'unconnect') return 'CAN_NOT_CONTACT'
    else if (appointmentStatus === 'change') return 'PUT_OFF'
    else if (appointmentStatus === 'enter') return 'CONFIRM'
    else if (appointmentStatus === 'unarrived') return 'NOT_YET'
    else if (appointmentStatus === 'pendingPayment') return 'PENDING_PAYMENT'
    else if (appointmentStatus === 'payment') return 'PAYMENT'
    else if (appointmentStatus === 'pendingService') return 'PENDING_SERVICE'
    else if (appointmentStatus === 'service') return 'SERVICE'
    else if (appointmentStatus === 'done') return 'DONE'
    else if (appointmentStatus === 'pushOff') return 'PUT_OFF'
    else return ''
  }

  const onSelectPatient = async (id: number) => {
    setSelectedLabOrders([])
    setStampSelectedLabOrders([])
    setPatientId(id)
    const res: any = await RegisterApi.findPatientById(id)
    const patientSelect: any = res.data
    if (patientSelect) {
      setPatient(patientSelect)
      setPatientId(id)
      setPhone(patientSelect?.phone || '')
      setSpecialInfo(patientSelect?.specialInfo || '')

      if (!_.find(formAppointments, { id: 'displayDataPrictice' }) || _.find(formAppointments, { id: 'displayDataPrictice' }).isShow) setPractice(patientSelect?.practice || [])
      else setPractice([])

      if (!_.find(formAppointments, { id: 'displayDataNote' }) || _.find(formAppointments, { id: 'displayDataNote' }).isShow) setRemark(patientSelect?.remark || [])
      else setRemark([])

    } else {
      setPatient(null)
      setPatientId(undefined)
      setPhone('')
      setSpecialInfo('')
      setPractice([])
      setRemark([])
    }

  }

  const handleNewPatient = (stageChange: boolean) => {
    setNewPatient(stageChange)
    setPatient(null)
    setPatientId(0)
    setPhone('')

    setPatientFirstname('')
    setPatientLastname('')
    setPatientPhone('')

    setSpecialInfo('')
    setSelectedLabOrders([])
    setStampSelectedLabOrders([])
    setLab(false)
  }

  const templateText = (type: string) => {
    setShowTemplateText(true)
    setTypeText(type)
  }

  const editSpecialInfo = (edit: boolean) => {
    setDisabled(edit)
    setInputSpecialInfo(edit)
    setSpecialInfoClone(specialInfo)
  }

  const saveSpecialInfo = async (edit: boolean) => {
    setDisabled(edit)
    setInputSpecialInfo(edit)
    const info = inputSpecialInfo ? specialInfoClone : specialInfo
    if (patientId === undefined) {
      notiError(t('APPOINTMENT.MESSAGE.SELECT_PATIENT'))
      return
    }

    setLoading(true)
    ClinicApi.updatePatientInfo({ specialInfo: info }, patientId).then(() => {
      notiSuccess(t('APPOINTMENT.MESSAGE.SAVE_PATIENT'), '', null, null)
    }).catch(() => {
      notiError('error')
    }).finally(() => {
      setLoading(false)
      setSpecialInfoClone(info)
      setSpecialInfo(info)
      if (props.setRerender) props.setRerender(!props.reRenderValue)
    })

  }

  const valInputTextArea = (val: string) => {
    if (val.charAt(0) === ',' || val.charAt(0) === ' ') {
      val = val.substring(1);
    }
    return val
  }

  const handlePatientIdApp = () => {
    const objDate = {
      year: moment(props.patientIdApp.date)?.year() || moment()?.year(),
      month: (moment(props.patientIdApp.date)?.month()) + 1,
      date: moment(props.patientIdApp.date)?.date() || moment()?.date(),
      day: props.viewDisplay === 'DATE' ? moment(props.patientIdApp.date).format('ddd') : (String(moment(props.patientIdApp.date)?.format('ddd')) || String(moment()?.format('ddd'))),
      branchId: branchId
    }
    props?.handleDate && props.handleDate(objDate)
    setDate(moment(props.patientIdApp.date).format('YYYY-MM-DD'))
    setTimeStart(moment(props.patientIdApp.timeStart, 'HH:mm:ss').format('HH:mm'))
    setDurationMinute(props.patientIdApp.durationMinute)

    setAppRemark(props.patientIdApp?.applicationDetail || [])
    setIsEdit(true)
    setObjAppontment(props.patientIdApp)
    loadPatients("", props.patientIdApp.patientId)
  }

  const renderAppointmentTitle = useCallback(() => {
    if (props.appointmentId && !disabled) {
      if (props?.patientIdApp?.patientId) {
        return t('APPOINTMENT.CREATE_APP')
      }
      return t('APPOINTMENT.UPDATE')
    } else if (disabled) {
      return t('APPOINTMENT.UPDATE_SPECIALINFO')
    } else {
      return t('APPOINTMENT.CREATE')
    }
  }, [props.appointmentId, disabled, isEdit])

  const [isSelectOperative, setIsSelectOperative] = useState<boolean>(false)


  const handleWorkTimeDoctor = useCallback(async () => {
    const condition: SchedulesAllProps = {
      branchId: branchId,
      date: date,
      doctorId: doctorId || 0
    }

    const res = await DoctorScheduleApi.findAll(condition)
    if (res.status === 200 && res?.data) {
      const [newSchedule] = res.data.filter((item: any) => item?.date === date)
      const [newData] = newSchedule?.schedule || []
      if (newData) {
        if (newData?.timeStart === "00:00:00" && newData?.timeEnd === "00:00:00") {
          setOfficeTimeByDay({ ...officeTimeByDay, timeIn: newData?.timeStart, timeOut: "23:55:00" })
        } else {
          setOfficeTimeByDay({ ...officeTimeByDay, timeIn: newData?.timeStart, timeOut: newData?.timeEnd })
        }
      } else {
        setOfficeTimeByDay({})
      }
    }

  }, [branchId, doctorId, dentists, props?.timeAppointment, date])

  useEffect(() => {
    if (props?.timeAppointment === TIME_APPOINTMENT.SCHEDULE && doctorId && _.find(dentists, { doctorId: doctorId })) {
      handleWorkTimeDoctor()
    } else {
      const day = moment(date).locale('en').format('ddd')
      setOfficeTimeByDay(_.find(props.officeTime, { dayOfWeek: day }) || {})
    }
  }, [date, props.officeTime, handleWorkTimeDoctor]);

  const renderForm = (id: string) => {
    if (!formAppointments?.length) {
      return ''
    }
    const permiss = _.find(formAppointments, { id })
    return permiss ? !_.get(permiss, 'isShow') ? 'd-none' : '' : ''
  }

  const renderReqDisForm = (id: string, status?: 'isRequired' | 'isDisabled') => {
    if (!formAppointments?.length) {
      return false
    }

    const keyName = status || 'isRequired'
    const permiss = _.find(formAppointments, { id })
    return permiss ? _.get(permiss, keyName) ? true : false : false
  }


  const onDelete = (appointmentId: number) => {
    if (appointmentId) {
      AppointmentApi.remove(appointmentId).then((resp) => {
        if (resp.status === 200) {
          setConfigAlert(initialConfigAlert)
          setIsOpenSnack(true)
          setTypeSnack("success")
          setLabelSnack(t('APPOINTMENT.MESSAGE.SUCCESS.DELETE'))
          if (props.reload) props.reload()
          if (props.onReset) props.onReset()
        } else {
          setConfigAlert(initialConfigAlert)
          setIsOpenSnack(true)
          setTypeSnack("error")
          setLabelSnack(t('APPOINTMENT.MESSAGE.ERROR'))
        }
      })
    }
  }

  const handleDeleteClick = (appointmentId: number) => {
    setConfigAlert({
      isOpen: true,
      title: t('APPOINTMENT.ALERT.CONFIRM_DELETE'),
      message: t('APPOINTMENT.ALERT.CONFIRM_DELETE_', {
        cnNumber: patient?.branchCnNumber,
        patientFullName: `${patient?.firstname} ${patient?.lastname}`,
        time: `${moment(timeStart, 'HH:mm:ss').format('HH:mm')}`
      }),
      type: 'error',
      children: [],  // ไม่มี children เพิ่มเติม
      onCancel: {
        onClick: () => setConfigAlert(initialConfigAlert),
        title: t('BUTTON.CANCEL')
      },
      onSubmit: {
        onClick: () => onDelete(appointmentId),
        title: t('BUTTON.SUBMIT')
      },
      handleClose: () => setConfigAlert(initialConfigAlert)
    })
  }

  const handleSelectLabOrder = (order: any) => {
    setStampSelectedLabOrders(prev => {
      const isSelected = prev.some(o => o.labOrderId === order.labOrderId);
      if (isSelected) {
        return prev.filter(o => o.labOrderId !== order.labOrderId);
      } else {
        return [...prev, order];
      }
    });
  };

  const handleConfirmSelectLabOrder = () => {
    setSelectedLabOrders(stampSelectedLabOrders);
    setSearchLab('')
    setIsLabOrderModalOpen(false);
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 600) {
        setHeight(200);
      } else if (window.innerWidth < 900) {
        setHeight(250);
      } else {
        setHeight(300);
      }
    };

    window.addEventListener('resize', handleResize);
    handleResize();

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (props.showForm && (props.appointmentId && (showEdit && isEdit) || true)) && (
    <>
      <AlertModal
        isOpen={configAlert.isOpen}
        title={configAlert.title}
        message={configAlert.message}
        type={configAlert.type}
        handleClose={() => configAlert.handleClose}
        onCancel={configAlert.onCancel}
        onSubmit={configAlert.onSubmit}
      >
        <Grid container spacing={2} marginBottom={2}>
          {configAlert.children?.map((c, i) => (
            <Grid item xs={12} key={i}>{c}</Grid>
          ))}
        </Grid>
      </AlertModal>
      <SnackbarComponent
        onOpen={isOpenSnack}
        onClose={() => setIsOpenSnack(false)}
        label={labelSnack}
        type={typeSnack}
        transform={`translateX(calc(100vw - 100% - 32px)) translateY(calc(-100vh + 100% + ${window.innerHeight - 50}px))`}
        autoHideTime={3000}
      />
      {showTemplateText && <PopupMessageAppointMent
        isShow={showTemplateText}
        type={typeText}
        setIsShow={(show: boolean) => {
          setShowTemplateText(show)
        }}
        setText={(text: any) => {
          if (text.length > 0) {
            if (typeText === 'PRATICE') setPractice([...practice, text.toString()])
            else if (typeText === 'APP') setAppRemark([...appRemark, text])
            else setRemark([...remark, text])
          }
        }} />}
      {props.typeForm}
      {props.typeForm !== "slice" ?
        <ModalCustom
          size={'xl'}
          title={renderAppointmentTitle()}
          alignFooter={'end'}
          fullscreen={'lg-down'}
          modalStyle={'modal-form-appointment'}
          component={
            <>
              <Loading show={loading} type="fullLoading" />
              <Row className={`mx-0 pt-2 pt-lg-0`}>
                <Col sm={12} lg={6} xl={6} className="mb-3 px-2">
                  <SearchPatients
                    status="ACTIVE"
                    bodyHeight={43}
                    disabled={newPatient || props.appointmentId ? true : false}
                    callbackPatientId={onSelectPatient}
                    patient={patient}
                    search={objAppontment?.patientFullname}
                    patientId={patientId}
                    onClear={() => onSelectPatient(0)}
                    helperText={errorMessage.PATIENT_ANY_REQUIRED || ''} />
                </Col>
                <Col sm={6} lg={3} xl={3} className={`mb-3 px-2 ${!props.appointmentId ? 'd-flex' : ''} ${renderForm('phone')}`}>
                  <InputTextField
                    id='phone'
                    required={true}
                    label={t('APPOINTMENT.FORM.PHONE')}
                    disabled={newPatient || props.appointmentId ? true : false}
                    type="text"
                    value={phone}
                    hookValue={true}
                    helperText={errorMessage.PHONE_STRING_EMPTY}
                    inputProps={{ shrink: true, maxLength: 50 }}
                    onchange={(e) => setPhone(e.target.value.replace(/[^0-9]/g, ''))}
                  />
                  {!props.appointmentId && (
                    <ButtonAddPatient className={`${newPatient ? 'add-disabled' : ''} ml-3 d-sm-none`} disabled={newPatient} onClick={() => handleNewPatient(true)} sx={{ flex: 'none', width: '42px' }}>
                      <Icons.IconUserPlus colors={newPatient ? colors.disabledGray : colors.themeSecondColor} />
                    </ButtonAddPatient>
                  ) || <></>}
                </Col>
                <Col sm={6} lg={3} xl={3} className="mb-3 px-2 d-none d-sm-block">
                  {props.appointmentId && (
                    <CustomBody apStatus={statusIcon[`${labelStatus}`]}>
                      <DropdownButton
                        className={'dropdownColor'}
                        onSelect={handleStatus}
                        as={ButtonGroup}
                        disabled={disabled ? disabled : statusIcon[`${labelStatus}`]?.disabled || disabled}
                        title={
                          <CustomBody className="d-inline">
                            <Image className="status-icon mr-2" style={{ marginTop: '-0.25rem' }} src={statusIcon[`${labelStatus}`]?.src || ''} alt={''} />
                            {statusIcon[`${labelStatus}`]?.label || t('APPOINTMENT.FORM.SELECT_STATUS')}
                          </CustomBody>
                        }>
                        {Object.keys(statusIcon).map((keyName, i) => (
                          <Dropdown.Item key={i} eventKey={keyName} disabled={statusIcon[`${keyName}`].disabled} active={status === renderStatus(keyName)}>
                            {statusIcon[`${keyName}`].label}
                          </Dropdown.Item>
                        ))}
                      </DropdownButton>
                    </CustomBody>
                  ) || (
                      <ButtonAddPatient className={`${newPatient ? 'add-disabled' : ''} d-none d-sm-flex align-items-center`} disabled={newPatient} onClick={() => handleNewPatient(true)}>
                        <Icons.IconUserPlus colors={newPatient ? colors.disabledGray : colors.themeSecondColor} />
                        <span className="ml-2">{t('APPOINTMENT.FORM.ADD_PATIENT')}</span>
                      </ButtonAddPatient>
                    )}
                </Col>
              </Row>
              {!newPatient && (
                <Row className={`mx-0 ${renderForm('spacialInfo')}`}>
                  <Col sm={12} className="w-100 px-2 mb-3 pb-1">
                    <Typography
                      sx={{
                        paddingBottom: '10px',
                        fontWeight: 500,
                        color: colors.themeMainColor,
                        svg: { width: '16px', height: '16px' }
                      }}>
                      <div className='d-flex'>
                        <div>
                          <Icons.IconStar stroke={colors.themeMainColor} />
                          <span className='ml-1 align-middle'>{t('REGISTER.PATIENT_SPACIAL_INFO')}</span>
                        </div>
                        <div className='ml-auto'>
                          {(props.appointmentId && !disabled) && <MainButton onClick={() => editSpecialInfo(true)} title={t('APPOINTMENT.UPDATE_SPECIALINFO')} type='primary' variant='outlined' style={{ width: '170px' }} />}
                        </div>
                      </div>
                    </Typography>
                    <InputTextarea
                      value={specialInfo}
                      disabled={(props.appointmentId && !disabled) || false}
                      onchange={(e) => {
                        setSpecialInfo(e.target.value)
                      }}
                    />
                  </Col>
                </Row>
              ) || <></>}
              <div className={`overflow-hidden ${newPatient ? 'd-block' : 'd-none'}`}>
                <LabelAddPatient>
                  {t('APPOINTMENT.FORM.ADD_PATIENT')}{' '}
                  <div className="d-inline-block d-lg-none mr-2" style={{ lineHeight: 0 }}>
                    <ImageDelete src={icons.iconDelete} onClick={(e) => handleNewPatient(false)} className="cursor-pointer" />
                  </div>
                </LabelAddPatient>
                <Row className={'mx-0 mt-3 mb-2 ml-4'}>
                  <Col md={6} lg={3} className="mb-3 px-2 pl-xl-3">
                    <InputTextField
                      required
                      label={t('APPOINTMENT.FORM.PATIENT_NAME')}
                      type="text"
                      value={patientFirstname}
                      inputProps={{ shrink: true }}
                      helperText={errorMessage.PATIENT_NAME_STRING_EMPTY}
                      onchange={(e) => setPatientFirstname(e.target.value)}
                    />
                  </Col>
                  <Col md={6} lg={3} className="mb-3 px-2">
                    <InputTextField
                      required
                      label={t('APPOINTMENT.FORM.PATIENT_LASTNAME')}
                      type="text"
                      value={patientLastname}
                      inputProps={{ shrink: true }}
                      helperText={errorMessage.PATIENT_LASTNAME_STRING_EMPTY}
                      onchange={(e) => setPatientLastname(e.target.value)}
                    />
                  </Col>
                  <Col md={6} lg={3} className="mb-3 px-2">
                    <InputTextField
                      required
                      label={t('APPOINTMENT.FORM.PATIENT_PHONE')}
                      type="text"
                      value={patientPhone}
                      inputProps={{ shrink: true, maxLength: 50 }}
                      helperText={errorMessage.PATIENT_PHONE_STRING_EMPTY}
                      onchange={(e) => (
                        setPatientPhone(e.target.value.replace(/[^0-9]/g, ''))
                      )}
                    />
                  </Col>
                  <Col sm={6} lg={3} className="d-none d-lg-flex align-items-center justify-content-right mb-3 pb-1">
                    <ImageDelete src={icons.iconDelete} onClick={(e) => handleNewPatient(false)} className="ml-auto cursor-pointer" />
                  </Col>
                </Row>
              </div>
              {props.appointmentId && (
                <Row className="d-sm-none mb-3 px-2">
                  <Col sm={12} className="w-100">
                    <CustomBody apStatus={statusIcon[`${labelStatus}`]}>
                      <DropdownButton
                        className={'dropdownColor'}
                        disabled={disabled ? disabled : statusIcon[`${labelStatus}`]?.disabled || disabled}
                        onSelect={handleStatus}
                        as={ButtonGroup}
                        title={
                          <CustomBody className="d-inline">
                            <Image className="status-icon mr-2" style={{ marginTop: '-0.25rem' }} src={statusIcon[`${labelStatus}`]?.src || ''} alt={''} />
                            {statusIcon[`${labelStatus}`]?.label || t('APPOINTMENT.FORM.SELECT_STATUS')}
                          </CustomBody>
                        }>
                        {Object.keys(statusIcon).map((keyName, i) => (
                          <Dropdown.Item key={i} eventKey={keyName} disabled={statusIcon[`${keyName}`].disabled} active={status === renderStatus(keyName)}>
                            {statusIcon[`${keyName}`].label}
                          </Dropdown.Item>
                        ))}
                      </DropdownButton>
                    </CustomBody>
                  </Col>
                </Row>
              ) || <></>}
              <Row className={`mx-0`}>
                <Col sm={6} xl={3} className={`mb-3 px-2  ${renderForm('date')}`}>
                  <InputSecondNewDatePicker
                    required
                    key={'date-of-birth'}
                    label={t('APPOINTMENT.FORM.DATE')}
                    value={date}
                    helperText={errorMessage.DATE_STRING_EMPTY || errorMessage.DATE_ANY_REQUIRED}
                    onchange={(e: any) => {
                      setDate(moment(e).format('YYYY-MM-DD'))
                      if (props.handleDate) {
                        const objDate = {
                          year: moment(e)?.year() || moment()?.year(),
                          month: (moment(e)?.month()) + 1,
                          date: moment(e)?.date() || moment()?.date(),
                          day: props.viewDisplay === 'DATE' ? moment(e).format('ddd') : (String(moment(e)?.format('ddd')) || String(moment()?.format('ddd')))
                        }
                        props.handleDate(objDate)
                      }
                    }}
                    disabled={disabled}
                  />

                  {errorMessage.DATE_STRING_EMPTY}
                </Col>
                <Col sm={6} xl={3} className={`mb-3 px-2 ${renderForm('branch')}`}>
                  <BasicSelect
                    required={true}
                    label={t('APPOINTMENT.FORM.BRANCH')}
                    value={branchId}
                    onchange={(event) => {
                      setBranchId(event.target.value)
                      setSelectedLabOrders([])
                      setStampSelectedLabOrders([])
                    }}
                    selectId="branch"
                    labelId="branch"
                    options={branches.map((br: any, i: number) => (
                      <MenuItem key={i} value={br.branchId}>
                        {br.branchName}
                      </MenuItem>
                    ))}
                    helperText={errorMessage.BRANCH_ANY_REQUIRED}
                    disabled={disabled}
                  />
                </Col>
                <Col sm={12} md={6} xl={3} className={`mb-3 px-2 ${renderForm('doctor')}`}>
                  <BasicSelect
                    required={true}
                    label={t('APPOINTMENT.FORM.DOCTOR')}
                    value={doctorId || ''}
                    onchange={(event) => setDoctorId(event.target.value)}
                    selectId="dentist"
                    labelId="dentist"
                    options={
                      dentists.length && (
                        dentists.map((dentist: DentistsInterface) => (
                          <MenuItem key={dentist.doctorId} value={dentist.doctorId}>
                            {dentist.doctorFullname}
                          </MenuItem>
                        ))
                      ) || (
                        <MenuItem key={'0'} disabled value={0}>
                          {t('APPOINTMENT.STATUS.NO')}{t('USER_DOCTOR')}{t('APPOINTMENT.BUTTON.ENTER_SHIFT_TODAY')}
                        </MenuItem>
                      )
                    }
                    helperText={errorMessage.DOCTOR_ANY_REQUIRED}
                    disabled={disabled}
                  />
                </Col>
                <Col sm={12} md={6} xl={3} className="px-2">
                  <Row className={`mx-0`}>
                    <Col sm={6} md={6} className={`mb-3 px-0 pr-sm-2 ${renderForm('timeStart')}`}>
                      <InputTimePickerAppointment
                        required={true}
                        key={'time'}
                        label={t('APPOINTMENT.FORM.TIME_START')}
                        value={timeStart ? moment(timeStart, 'HH:mm:ss').format('HH:mm') : ''}
                        helperText={errorMessage.TIME_START_ANY_REQUIRED || errorMessage.DATE_STRING_EMPTY || errorMessage.DATE_ANY_REQUIRED}
                        onChange={(e: any) => {
                          setTimeStart(e.format('HH:mm'))
                        }}
                        disabled={disabled || officeTimeByDay.officeStatus === "CLOSE"}
                        scopeTimeStart={officeTimeByDay?.timeIn || '00:00'}
                        scopeTimeEnd={officeTimeByDay?.timeOut || '00:00'} />
                    </Col>
                    <Col sm={6} md={6} className={`mb-3 px-0 pl-sm-2 ${renderForm('duration')}`}>
                      <BasicSelect
                        required={true}
                        label={t('APPOINTMENT.FORM.PERIOD')}
                        value={durationMinute || ''}
                        onchange={(event) => setDurationMinute(event.target.value)}
                        selectId="durationMinute"
                        labelId="durationMinute"
                        options={durationMinutes.map((duration: any, i: number) => (
                          <MenuItem key={i} value={duration.durationMinute}>
                            {`${duration.duration} ${t(`TIME_DURATION_TYPE.${duration.durationType}`)}`}
                          </MenuItem>
                        ))}
                        helperText={errorMessage.DURATION_MINUTE_ANY_REQUIRED}
                        disabled={disabled || officeTimeByDay.officeStatus === "CLOSE"}
                      />
                    </Col>
                  </Row>
                </Col>
              </Row>
              <div className={`mb-3 px-2 ${labelStatus === 'cancel' ? '' : 'd-none'}`} style={{ display: isEdit ? '' : 'none' }}>
                <InputTextarea disabled={disabled} required onchange={(e) => setRemarkCancel(e.target.value)} value={remarkCancel} label={t('APPOINTMENT.FORM.REMARK_CANCEL')} helperText={errorMessage.REMARK_CANCEL_ANY_REQUIRED || errorMessage.REMARK_CANCEL_STRING_EMPTY} />
              </div>
              <Row className={`mx-0 ${checkPackage(PACKAGE_ADDONS.ADDON_X_RAY) || checkPackage(PACKAGE_ADDONS.ADDON_LAB) ? 'mb-2' : ''}`}>
                <Col sm={6} lg={9} className={`mb-3 px-2 ${renderForm('treatment')}`}>
                  <AutocompleteSelect
                    multiple
                    required={true}
                    labelId="lb-operative-id"
                    inputLabel={t('REGISTER.SEND_EXAMINATION.TREATMENT_LIST')}
                    noOptionsText={t('REGISTER.FORM.NOT_FOUND')}
                    options={operativeTypes}
                    getOptionLabel={(option: any) => (option.operativeId ? option.operativeName : option.operativeTypeName)}
                    renderOption={(props, option: any) => (
                      <Box
                        key={`${option.operativeId ? `operativeId-${option.operativeId}` : `operativeTypeId-${option.operativeTypeId}`}`}
                        component="li"
                        style={{
                          pointerEvents: _.some(operativeType, (i: any, index: number) => i.operativeTypeId === option.operativeTypeId && i.operativeId === option.operativeId) ? 'none' : '',
                          backgroundColor: _.some(operativeType, (i: any, index: number) => i.operativeTypeId === option.operativeTypeId && i.operativeId === option.operativeId) ? colors.themeSecondColor06 : colors.white,
                          color: _.some(operativeType, (i: any, index: number) => i.operativeTypeId === option.operativeTypeId && i.operativeId === option.operativeId) ? colors.themeSecondColor : null
                        }}
                        {...props}
                      >
                        <span style={{ paddingLeft: option.operativeId ? '1rem' : '' }}>{option.operativeId ? option.operativeName : option.operativeTypeName}</span>
                      </Box>
                    )}
                    renderTags={(tagValue, getTagProps) =>
                      tagValue.map((option: any, index: any) => (
                        <div key={`index-${index}`}>
                          <Chip label={option.operativeName ? option.operativeName : option.operativeTypeName} style={{ fontSize: '1rem', backgroundColor: option.color }} {...getTagProps({ index })} />
                        </div>
                      ))
                    }
                    onchange={(event, val) => setOperativeType(_.map(val, (v) => v))}
                    onInputChange={(event: any, newValue: any) => loadDataTreatmentItems(newValue)}
                    value={operativeType ? operativeType : []}
                    key={'treatment'}
                    height={43}
                    limitTags={3}
                    errMessage={errorMessage.APPOINTMENT_OPERATIVES_ANY_REQUIRED}
                    disabled={disabled}
                  />
                </Col>
                <Col sm={6} lg={3} className={`mb-3 px-2 ${renderForm('price')}`}>
                  <InputTextField
                    label={t('APPOINTMENT.FORM.PRICE')}
                    type="text"
                    value={price}
                    inputProps={{ shrink: true, inputProps: { min: 0, max: 10 } }}
                    onchange={(e) => {
                      const val = e.target.value.replace(/[^0-9]/g, '')
                      if (val < 0) setPrice(0)
                      else if (val > 900000) setPrice(900000)
                      else setPrice(val)
                    }}
                    disabled={disabled}
                  />
                </Col>
              </Row>
              <Row className="mx-0">
                {checkPackage(PACKAGE_ADDONS.ADDON_X_RAY) && (
                  <Col xs={12} xl={'auto'} className={`px-0 ${renderForm('lab')}`}>
                    <Row className="mx-0">
                      <Col xs={12} sm={3} xl={'auto'} className="px-2 pt-sm-2">
                        <span className={`formLabel fw-700`}>{t('APPOINTMENT.FORM.LIST_ORDER_LAB')}</span>
                      </Col>
                      <Col xs={12} sm={9} xl={'auto'} className="mb-2 px-2 pl-4">
                        <FormControl>
                          <RadioGroup row aria-labelledby="demo-row-radio-buttons-group-label" name="row-radio-buttons-group">
                            <FormControlLabel disabled={disabled} value="lab" control={<InputRadio checked={lab === true} className="radio" onClick={(e: any) => setLab(true)} />} label={t('APPOINTMENT.FORM.HAS_LAB')} />
                            <FormControlLabel disabled={disabled} value="nonlab" control={<InputRadio checked={lab === false} onClick={(e: any) => setLab(false)} />} label={t('APPOINTMENT.FORM.NOT_HAS_LAB')} />
                          </RadioGroup>
                        </FormControl>
                      </Col>
                    </Row>
                  </Col>
                )}
                {checkPackage(PACKAGE_ADDONS.ADDON_LAB) && (
                  <Col xs={12} xl={'auto'} className={`px-0 ${renderForm('xray')}`}>
                    <Row className="mx-0">
                      <Col xs={12} sm={3} xl={'auto'} className="px-2 pt-sm-2">
                        <span className={`formLabel fw-700`}>{t('APPOINTMENT.FORM.LIST_ORDER_XRAY')}</span>
                      </Col>
                      <Col xs={12} sm={9} xl={'auto'} className="mb-2 px-2 pl-4">
                        <FormControl>
                          <RadioGroup row aria-labelledby="demo-row-radio-buttons-group-label" name="row-radio-buttons-group">
                            <FormControlLabel disabled={disabled} value="xray" control={<InputRadio checked={xray === true} onClick={(e: any) => setXray(true)} />} label={t('APPOINTMENT.FORM.HAS_XRAY')} />
                            <FormControlLabel disabled={disabled} value="nonxray" control={<InputRadio checked={xray === false} onClick={(e: any) => setXray(false)} />} label={t('APPOINTMENT.FORM.NOT_HAS_XRAY')} />
                          </RadioGroup>
                        </FormControl>
                      </Col>
                    </Row>
                  </Col>
                )}
              </Row>
              <div className={`d-flex mb-3 px-2 ${checkPackage(PACKAGE_ADDONS.ADDON_X_RAY) || checkPackage(PACKAGE_ADDONS.ADDON_LAB) ? 'mt-2' : ''} ${renderForm('prictice')}`}>
                <InputTextarea disabled={disabled} value={practice.toString()} onchange={(event) => setPractice([event.target.value])} label={t('APPOINTMENT.FORM.PRACTICE')} helperText={''} />
                <Box className='input-form-note-wrap position-absolute'></Box>
                <ButtonCustom disabled={disabled} onClick={() => templateText('PRATICE')} textButton={<img src={icons.iconFeatherEdit} alt="" style={{ width: 24 }} />} className="h-100" style={{ margin: 0, height: '89px' }} />
              </div>
              <div className={`px-2`}>
                <hr className="my-lg-4 " />
              </div>
              <div className={`d-flex mb-3 mt-2 px-2 ${renderForm('note')}`}>
                <InputTextarea disabled={disabled} value={remark.toString()} onchange={(event) => setRemark([event.target.value])} label={t('APPOINTMENT.FORM.REMARK')} helperText={''} />
                <Box className='input-form-note-wrap position-absolute'></Box>
                <ButtonCustom disabled={disabled} onClick={() => templateText('REMARK')} textButton={<img src={icons.iconFeatherEdit} alt="" style={{ width: 24 }} />} className="h-100" style={{ margin: 0, height: '89px' }} />
              </div>
            </>
          }
          onSubmit={handleSubmit}
          onReset={() => {
            resetForm()
          }}
          onDelete={(id: number, obj: any) => {
            props.onDelete && props.onDelete(id, obj)
            resetForm()
          }}
          id={props.appointmentId}
          obj={objAppontment}
          disabledSubmit={loading}
          textBtnCancel={t('APPOINTMENT.FORM.CANCEL')}
          textBtnDelete={!disabled ? t('APPOINTMENT.BUTTON.DEL') : ''}
          textBtnConfirm={props.appointmentId && !disabled ? t('APPOINTMENT.FORM.SAVE') : disabled ? t('APPOINTMENT.FORM.SAVE_SPECIALINFO') : t('APPOINTMENT.FORM.ADD')}
        />
        :
        <>
          <ModalSlice className={'appointment-form'}>
            <Loading show={loading} type="fullLoading" />
            <div className='pt-2 pl-3 pr-3 pb-0 form-appointment'>
              <ModalSliceTitle>
                {renderAppointmentTitle()}
                <div style={{ position: "absolute", top: "0", right: "0", padding: "8px 16px", }}>
                  {props.appointmentId && (
                    <CustomBody apStatus={statusIcon[`${labelStatus}`]}>
                      <DropdownButton
                        style={{ height: "35px" }}
                        className={'dropdownColor buttonFromAppoint'}
                        onSelect={handleStatus}
                        as={ButtonGroup}
                        disabled={labelStatus === 'unarrived' || labelStatus === 'arrived' ? false : disabled ? disabled : statusIcon[`${labelStatus}`]?.disabled || disabled}
                        title={
                          <CustomBody className="d-inline" style={{ fontSize: "14px" }}>
                            <Image
                              className="status-icon mr-2"
                              style={{
                                marginTop: '-0.25rem',
                                height: statusIcon[`${labelStatus}`]?.src ? "15px" : "0",
                                width: statusIcon[`${labelStatus}`]?.src ? "15px" : "0"
                              }} src={statusIcon[`${labelStatus}`]?.src || ""}
                              alt={''}
                            />
                            {statusIcon[`${labelStatus}`]?.label || t('APPOINTMENT.FORM.SELECT_STATUS')}
                          </CustomBody>
                        }>
                        {Object.keys(statusIcon).map((keyName, i) => {
                          if ((status === 'NOT_YET' || status === 'CONFIRM') && keyName === 'normal') statusIcon[keyName].disabled = true;
                          return (
                            <Dropdown.Item key={i} eventKey={keyName} disabled={statusIcon[`${keyName}`].disabled} active={status === renderStatus(keyName)}>
                              <Box display='flex' flexDirection='row' >
                                <Box style={{
                                  width: '20px',
                                  height: '20px',
                                  backgroundColor: statusIcon[`${keyName}`]?.color || "",
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  marginRight: '5px'
                                }}
                                >
                                  <Image
                                    style={{
                                      height: statusIcon[`${keyName}`]?.src ? "15px" : "0",
                                      width: statusIcon[`${keyName}`]?.src ? "15px" : "0",
                                    }}
                                    src={statusIcon[`${keyName}`]?.src || ""}
                                    alt={''}
                                  />
                                </Box>
                                <Box>{statusIcon[`${keyName}`].label}</Box>
                              </Box>
                            </Dropdown.Item>
                          )
                        })}
                      </DropdownButton>
                    </CustomBody>
                  ) || (
                      <ButtonAddPatient
                        className={`${newPatient ? 'add-disabled' : ''} d-none d-sm-flex align-items-center`}
                        disabled={newPatient}
                        onClick={() => handleNewPatient(true)}
                        style={{ width: "30px", height: "30px" }}
                      >
                        <Icons.IconUserPlus colors={newPatient ? colors.disabledGray : colors.themeSecondColor} />
                      </ButtonAddPatient>
                    )}
                </div>

              </ModalSliceTitle>
              <hr style={{ margin: "1rem 0 1rem 0 " }} />
              <div className=''>
                <div className={`mx-0 pt-2 pt-lg-0 p-0`}>
                  <Col sm={12} lg={12} xl={12} className="">
                    <SearchPatients
                      bodyHeight={30}
                      bodyWidth={"28%"}
                      disabled={newPatient || props.appointmentId ? true : false}
                      callbackPatientId={onSelectPatient}
                      patient={patient}
                      search={objAppontment.patientFullname}
                      patientId={patientId}
                      onClear={() => onSelectPatient(0)}
                      status="ACTIVE"
                      helperText={errorMessage.PATIENT_ANY_REQUIRED || ''} />
                  </Col>
                </div>
                <div className={`mt-3 `}>
                  <Col sm={12} lg={12} xl={12} className={` ${!props.appointmentId ? 'd-flex' : ''} ${renderForm('phone')}`}>
                    <InputTextField
                      inputHeight={40}
                      required={true}
                      label={t('APPOINTMENT.FORM.PHONE')}
                      disabled={newPatient || props.appointmentId ? true : false}
                      type="text"
                      value={phone}
                      hookValue={true}
                      helperText={errorMessage.PHONE_STRING_EMPTY}
                      inputProps={{ shrink: true, maxLength: 50 }}
                      onchange={(e) => setPhone(e.target.value)}
                    />
                    {!props.appointmentId && (
                      <ButtonAddPatient className={`${newPatient ? 'add-disabled' : ''} ml-3 d-sm-none`} disabled={newPatient} onClick={() => handleNewPatient(true)} sx={{ flex: 'none', width: '42px' }}>
                        <Icons.IconUserPlus colors={newPatient ? colors.disabledGray : colors.themeSecondColor} />
                      </ButtonAddPatient>
                    ) || <></>}
                  </Col>
                </div>
                <Box className={`${renderForm('spacialInfo')}`}>
                  <div className={`mt-2`}>
                    {!newPatient && (
                      <Col sm={12} className={`w-100 mb-3 pb-1`}>
                        <Typography
                          sx={{
                            paddingBottom: '10px',
                            fontWeight: 500,
                            color: colors.themeMainColor,
                            svg: { width: '16px', height: '16px' }
                          }}>
                          <div className='d-flex'>
                            <div>
                              <Icons.IconStar stroke={colors.themeMainColor} />
                              <span className='ml-1 align-middle'>
                                {t('REGISTER.PATIENT_SPACIAL_INFO')}
                              </span>
                            </div>
                            <div className="ml-auto">
                              {patientId && !disabled ? (
                                <MainButton
                                  onClick={() => editSpecialInfo(true)}
                                  title={t('APPOINTMENT.UPDATE_SPECIALINFO')}
                                  type='primary'
                                  variant='outlined'
                                  style={{ width: '180px' }}
                                />
                              ) : (
                                <MainButton
                                  onClick={() => saveSpecialInfo(false)}
                                  title={t('APPOINTMENT.SAVE_SPECIALINFO')}
                                  type='primary'
                                  variant='outlined'
                                  style={{ width: '180px' }}
                                />
                              )
                              }
                            </div >
                          </div >
                        </Typography >
                        <InputTextarea
                          value={inputSpecialInfo ? specialInfoClone : specialInfo}
                          disabled={(patientId && !disabled) || false}
                          onchange={(e) => {
                            clearErrorMessage()
                            if (inputSpecialInfo) {
                              setSpecialInfoClone(e.target.value)
                            } else {
                              setSpecialInfo(e.target.value)
                            }
                          }}
                        //   helperText={errorMessage?.SPACIAL_INFO_REQUIRED && (inputSpecialInfo ? specialInfoClone : specialInfo) === "" ? errorMessage?.SPACIAL_INFO_REQUIRED : ''}
                        />
                      </Col >
                    ) || <></>
                    }
                  </div >
                  <hr style={{ margin: "1rem 0 0 0 " }} />
                </Box >

                <div className={`overflow-hidden ${newPatient ? 'd-block' : 'd-none'} mt-3`}>
                  <LabelAddPatient style={{ margin: "0 0 1rem 0", paddingRight: "16px", fontSize: "14px" }}>
                    {props.appointmentId ? t('APPOINTMENT.FORM.EDIT_PATIENT') : t('APPOINTMENT.FORM.ADD_PATIENT')}{' '}
                    {!props.appointmentId ?
                      <div className="" style={{ lineHeight: 0 }}>
                        <ImageDelete src={icons.iconDelete} onClick={(e) => handleNewPatient(false)} className="cursor-pointer" />
                      </div> :
                      <></>
                    }
                  </LabelAddPatient>
                  <Row className={``}>
                    <Col xs={12} md={6} lg={6} className="mb-3 pr-sm-2">
                      <InputTextField
                        required
                        label={t('APPOINTMENT.FORM.PATIENT_NAME')}
                        type="text"
                        value={patientFirstname}
                        inputProps={{ shrink: true }}
                        helperText={errorMessage.PATIENT_NAME_STRING_EMPTY}
                        onchange={(e) => setPatientFirstname(e.target.value)}
                      />
                    </Col>
                    <Col xs={12} md={6} lg={6} className="mb-3 pl-sm-2">
                      <InputTextField
                        required
                        label={t('APPOINTMENT.FORM.PATIENT_LASTNAME')}
                        type="text"
                        value={patientLastname}
                        inputProps={{ shrink: true }}
                        helperText={errorMessage.PATIENT_LASTNAME_STRING_EMPTY}
                        onchange={(e) => setPatientLastname(e.target.value)}
                      />
                    </Col>
                  </Row>

                  <Col md={12} lg={12} className="mb-3">
                    <InputTextField
                      required
                      label={t('APPOINTMENT.FORM.PATIENT_PHONE')}
                      type="text"
                      value={patientPhone}
                      inputProps={{ shrink: true, maxLength: 50 }}
                      helperText={errorMessage.PATIENT_PHONE_STRING_EMPTY}
                      onchange={(e) => (
                        setPatientPhone(e.target.value.replace(/[^0-9]/g, ''))
                      )}
                    />
                  </Col>
                  <hr style={{ margin: "1rem 0 0rem 0 " }} />
                </div>

                <Row className={`mt-3`}>
                  <Col xs={12} sm={6} xl={6} className={`mb-3 pr-sm-2 ${renderForm('branch')}`}>
                    <BasicSelect
                      required={true}
                      label={t('APPOINTMENT.FORM.BRANCH')}
                      value={branchId}
                      onchange={(event) => {
                        setTimeStart(undefined)
                        setDoctorId(0)
                        setBranchId(event.target.value)
                        setSelectedLabOrders([])
                        setStampSelectedLabOrders([])
                      }}
                      selectId="branch"
                      labelId="branch"
                      options={branches.map((br: any, i: number) => (
                        <MenuItem
                          key={i}
                          value={br.branchId}
                          onClick={() => {
                            if (props.handleBranch) {
                              props.handleBranch(br.branchId)
                            }
                          }}>
                          {br.branchName}
                        </MenuItem>
                      ))}
                      helperText={errorMessage.BRANCH_ANY_REQUIRED}
                      disabled={disabled}

                    />
                  </Col>
                  <Col xs={12} sm={6} xl={6} className={`mb-3 pl-sm-2 ${renderForm('date')}`}>
                    <InputSecondNewDatePicker
                      required
                      key={'date-of-birth'}
                      label={t('APPOINTMENT.FORM.DATE')}
                      value={date}
                      helperText={errorMessage.DATE_STRING_EMPTY || errorMessage.DATE_ANY_REQUIRED}
                      onchange={(e: any) => {
                        const dateObject = new Date(e)
                        if (e.length === 10 && dateObject instanceof Date && !isNaN(dateObject.getTime())) {
                          setDate(moment(e).format('YYYY-MM-DD'))
                          if (props.handleDate) {
                            const objDate = {
                              year: moment(e)?.year() || moment()?.year(),
                              month: (moment(e)?.month()) + 1,
                              date: moment(e)?.date() || moment()?.date(),
                              day: props.viewDisplay === 'DATE' ? moment(e).format('ddd') : (String(moment(e)?.format('ddd')) || String(moment()?.format('ddd'))),
                              branchId: branchId
                            }
                            props.handleDate(objDate)
                          }
                        } else {
                          if (props.handleDate) {
                            const objDate = {
                              year: moment(e)?.year() || moment()?.year(),
                              month: (moment(e)?.month()) + 1,
                              date: moment(e)?.date() || moment()?.date(),
                              day: props.viewDisplay === 'DATE' ? moment(e).format('ddd') : (String(moment(e)?.format('ddd')) || String(moment()?.format('ddd'))),
                              branchId: branchId
                            }
                            props.handleDate(objDate)
                          }
                          setDate(e)
                        }

                      }}
                      disabled={disabled}
                      pointerEvent={"auto"}
                      placeholder="--/--/----"
                      inputEdit={true}
                    />
                    {errorMessage.DATE_STRING_EMPTY}
                  </Col>
                  <Col sm={12} md={12} xl={12} className={`mb-3 ${renderForm('doctor')}`}>
                    <AutocompleteSelect
                      required={true}
                      inputLabel={t('APPOINTMENT.FORM.DOCTOR')}
                      noOptionsText={t('REGISTER.FORM.NOT_FOUND')}
                      value={dentists && doctorId ? _.find(dentists, { doctorId: doctorId }) : null}
                      onchange={(event, val) => {
                        setDoctorId(val.doctorId)
                      }
                      }
                      labelId="dentist"
                      options={dentists}
                      getOptionLabel={(option: any) => option.doctorFullname}
                      errMessage={errorMessage.DOCTOR_ANY_REQUIRED}
                      disabled={disabled}
                      disableClearable
                    />
                  </Col>
                  <Col sm={12} md={12} xl={12} className={` `}>
                    <Row className={``}>
                      <Col sm={6} md={6} className={`mb-3 pr-sm-2 ${renderForm('timeStart')} `}>
                        <InputTimePickerAppointment
                          required={true}
                          key={'time'}
                          label={t('APPOINTMENT.FORM.TIME_START')}
                          value={timeStart && timeStart.length === 5 ? moment(timeStart, 'HH:mm:ss').format('HH:mm') : timeStart}
                          helperText={errorMessage.TIME_START_ANY_REQUIRED || errorMessage.DATE_STRING_EMPTY || errorMessage.DATE_ANY_REQUIRED}
                          onChange={(e: any) => {
                            if (e?.target?.value) {
                              setTimeStart(e.target.value)
                            } else {
                              if (!e?.target) {
                                setTimeStart(
                                  e.format('HH') === '00'
                                    ? `${officeTimeByDay?.timeIn?.slice(0, 2)}:${e.format('mm')}`
                                    : (e.format('HH') === `${officeTimeByDay?.timeOut?.slice(0, 2)}` ? moment(officeTimeByDay?.timeOut, 'HH:mm:ss').format('HH:mm')
                                      : e.format('HH:mm'))
                                );
                              } else {
                                setTimeStart('')
                              }
                            }
                            clearErrorMessage()
                          }}
                          inputText={true}
                          disabled={disabled || officeTimeByDay.officeStatus === "CLOSE"}
                          scopeTimeStart={officeTimeByDay?.timeIn || '00:00'}
                          scopeTimeEnd={officeTimeByDay?.timeOut || '00:00'}
                        />
                      </Col>
                      <Col sm={6} md={6} className={`mb-3 pl-sm-2 ${renderForm('duration')}`}>
                        <BasicSelect
                          required={true}
                          label={t('APPOINTMENT.FORM.DURA_MINUTE')}
                          value={durationMinute || ''}
                          onchange={(event) => setDurationMinute(event.target.value)}
                          selectId="durationMinute"
                          labelId="durationMinute"
                          options={durationMinutes.map((duration: any, i: number) => (
                            <MenuItem key={i} value={duration.durationMinute}>
                              {`${duration.duration} ${t(`TIME_DURATION_TYPE.${duration.durationType}`)}`}
                            </MenuItem>
                          ))}
                          helperText={errorMessage.DURATION_MINUTE_ANY_REQUIRED}
                          disabled={disabled || officeTimeByDay.officeStatus === "CLOSE"}
                        />
                      </Col>
                    </Row>
                  </Col>
                </Row>
                <div className={`mb-3 ${labelStatus === 'cancel' ? '' : 'd-none'}`} style={{ display: isEdit ? '' : 'none' }}>
                  <InputTextarea disabled={disabled} required onchange={(e) => setRemarkCancel(e.target.value)} value={remarkCancel} label={t('APPOINTMENT.FORM.REMARK_CANCEL')} helperText={errorMessage.REMARK_CANCEL_ANY_REQUIRED || errorMessage.REMARK_CANCEL_STRING_EMPTY} />
                </div>
                <Row className={` ${checkPackage(PACKAGE_ADDONS.ADDON_X_RAY) || checkPackage(PACKAGE_ADDONS.ADDON_LAB) ? 'mb-2' : ''}`}>
                  <Col sm={12} lg={12} className={`mb-3 ${renderForm('treatment')}`}>
                    <Box sx={{
                      '.MuiInputBase-input': {
                        height: `10px !important`,
                      },
                      '.MuiAutocomplete-option': {
                        '&:hover, &:hover.Mui-focused': {
                          backgroundColor: `${colors.themeSecondColor06} !important`,
                          color: colors.themeSecondColor
                        },
                        '&[aria-selected="true"], &.Mui-focused': {
                          backgroundColor: `${colors.transparent} !important`,
                        }
                      }
                    }}>
                      <AutocompleteSelect
                        open={isSelectOperative}
                        onOpen={(event, value) => setIsSelectOperative(true)}
                        onClose={(event, value) => setIsSelectOperative(false)}
                        multiple
                        required={true}
                        labelId="lb-operative-id"
                        inputLabel={t('REGISTER.SEND_EXAMINATION.TREATMENT_LIST')}
                        noOptionsText={t('REGISTER.FORM.NOT_FOUND')}
                        options={[...operativeTypes, ...newTreatmentItems]}
                        getOptionLabel={(option: any) => (option.operativeId ? option.operativeName : option.operativeTypeName)}
                        // getOptionLabel={(option: any) => (option?.subOperative[0]?.operativeName || option.operativeTypeName)}
                        renderOption={(props, option: any) => (
                          <Box
                            key={`${option.operativeId ? `operativeId-${option.operativeId}` : `operativeTypeId-${option.operativeTypeId}`}`}
                            component="li"
                            style={{
                              pointerEvents: _.some(operativeType, (i: any, index: number) => i.operativeTypeId === option.operativeTypeId && i.operativeId === option.operativeId) ? 'none' : '',
                              backgroundColor: _.some(operativeType, (i: any, index: number) => i.operativeTypeId === option.operativeTypeId && i.operativeId === option.operativeId) ? colors.themeSecondColor06 : colors.white,
                              color: _.some(operativeType, (i: any, index: number) => i.operativeTypeId === option.operativeTypeId && i.operativeId === option.operativeId) ? colors.themeSecondColor : null
                            }}
                            {...props}
                          >
                            <span style={{ paddingLeft: option.operativeId ? '1rem' : '' }}>{option.operativeId ? option.operativeName : option.operativeTypeName}</span>
                            {/* <CollapseOperatice
                              data={operativeType}
                              option={option}
                              seletor={props}
                              handleSubClick={handleSubClickOperative}
                            /> */}
                          </Box>
                        )}
                        renderTags={(tagValue, getTagProps) =>
                          tagValue.map((option: any, index: any) => {
                            const labelChip = option.operativeName ? option.operativeName : option.operativeTypeName
                            return (
                              <Tooltip title={`${labelChip}`} placement="left" key={`index-${index}`}>
                                <div style={{ overflow: "hidden" }} >
                                  <Chip label={labelChip} style={{ fontSize: '1rem', backgroundColor: option.color }} {...getTagProps({ index })} />
                                </div>
                              </Tooltip>
                            )
                          })
                        }
                        onchange={(event, val) => {
                          setOperativeType(_.map(val, (v) => v))
                        }}
                        onInputChange={(event: any, newValue: any) => loadDataTreatmentItems(newValue)}
                        value={operativeType ? operativeType : []}
                        key={'treatment'}
                        height={43}
                        limitTags={3}
                        errMessage={errorMessage.APPOINTMENT_OPERATIVES_ANY_REQUIRED}
                        params={{
                          PaperComponent: undefined,
                          ListboxProps: {
                            ref: treatmentItemsRef,
                            onScroll: (event: any) => {
                              const elementScrollCurrent = (event?.target?.scrollTop + event?.target?.offsetHeight) || 0
                              const elementScrollMax = event?.target?.scrollHeight || 0
                              if ((elementScrollCurrent && elementScrollMax) &&
                                ((elementScrollCurrent + 0.5) >= elementScrollMax) &&
                                handleLengthOperative()) {
                                setContentMaxTI(elementScrollMax)
                                loadDataTreatmentItems(treatmentItemsSearch, true)
                              }
                            }
                          },
                        }}
                        disabled={labelStatus === 'done'}
                      />
                    </Box>
                  </Col>
                  <Col sm={12} lg={12} className={`${renderForm('price')}`}>
                    <InputTextField
                      label={t('APPOINTMENT.FORM.PRICE')}
                      type="text"
                      value={price}
                      inputProps={{ shrink: true, inputProps: { min: 0, max: 10 } }}
                      onchange={(e) => {
                        clearErrorMessage()
                        const val = e.target.value.replace(/[^0-9]/g, '')
                        if (val < 0) setPrice(0)
                        else if (val > 900000) setPrice(900000)
                        else setPrice(val)
                      }}
                      disabled={disabled}
                      required={renderReqDisForm('price')}
                      helperText={errorMessage?.PRICE_REQUIRED && !price ? errorMessage?.PRICE_REQUIRED : ''}
                    />
                  </Col>
                </Row>
                <hr style={{ margin: "1rem 0 1rem 0 " }} />
                <Row className="mx-0 pl-3">
                  {checkPackage(PACKAGE_ADDONS.ADDON_X_RAY) && (
                    <Col xs={12} xl={'auto'} className={`px-0 ${renderForm('lab')}`}>
                      <Row className="" style={{ alignItems: "center" }}>
                        <Col xs={12} sm={5} xl={'auto'} className="" style={{ fontSize: "14px", padding: "0 12px 0 12px" }}>
                          <span className={`formLabel fw-700`}>
                            {t('APPOINTMENT.FORM.LIST_ORDER_LAB')}
                            {renderReqDisForm('lab') && <span style={{ color: colors.statusInactive }}>*</span>}
                          </span>
                        </Col>
                        <Col xs={12} sm={7} xl={'auto'} className="mb-0 pl-1 d-flex align-items-center flex-wrap" style={{ gap: '16px' }}>
                          <FormControl>
                            <RadioGroup row aria-labelledby="demo-row-radio-buttons-group-label" name="row-radio-buttons-group">
                              <FormControlLabel style={{ fontSize: "14px" }} disabled={disabled} value="lab" control={<InputRadio checked={lab === true} className="radio" onClick={(e: any) => setLab(true)} />} label={t('APPOINTMENT.FORM.HAS_LAB')} />
                              <FormControlLabel style={{ fontSize: "14px" }} disabled={disabled} value="nonlab" control={<InputRadio checked={lab === false}
                                onClick={(e: any) => {
                                  setLab(false)
                                  setStampSelectedLabOrders([])
                                  setSelectedLabOrders([])
                                }
                                } />} label={t('APPOINTMENT.FORM.NOT_HAS_LAB')} />
                            </RadioGroup>
                          </FormControl>
                          {window.innerWidth > 1600 && <MainButton title={t('APPOINTMENT.LAB_ORDER.BUTTON.SELECT_FORM_LAB')} type='primary' variant='outlined' onClick={() => {
                            setStampSelectedLabOrders(selectedLabOrders);
                            setIsLabOrderModalOpen(true);
                          }} disabled={!(patientId && branchId && date) || !lab} />}
                        </Col>
                        {window.innerWidth < 1600 && <Col xs={12} sm={7} md={12} xl={12} className="mb-0 pl-1 d-flex align-items-center flex-wrap justify-content-end">
                          <MainButton title={t('APPOINTMENT.LAB_ORDER.BUTTON.SELECT_FORM_LAB')} type='primary' variant='outlined' onClick={() => {
                            setStampSelectedLabOrders(selectedLabOrders);
                            setIsLabOrderModalOpen(true);
                          }} disabled={!(patientId && branchId && date) || !lab} />
                        </Col>}
                        <Col style={{ marginTop: '10px', marginRight: '16px' }}>
                          <div style={selectedLabOrders.length > 2 ? { maxHeight: '300px', overflowY: 'auto' } : {}}>
                            {selectedLabOrders.map((order: any) => (
                              LabOrderCard(t, order, date, true, undefined, () => handleCancelLabOrder(order.labOrderId))
                            ))}
                          </div>
                        </Col>
                      </Row>
                    </Col>
                  )}
                  {checkPackage(PACKAGE_ADDONS.ADDON_LAB) && (
                    <Col xs={12} xl={'auto'} className={`px-0 ${renderForm('xray')}`}>
                      <Row className="" style={{ alignItems: "center" }}>
                        <Col xs="auto" className="" style={{ fontSize: "14px", padding: "0 12px 0 12px", }}>
                          <span className={`formLabel fw-700`}>
                            {t('APPOINTMENT.FORM.LIST_ORDER_XRAY')}
                            {renderReqDisForm('xray') && <span style={{ color: colors.statusInactive }}>*</span>}
                          </span>
                        </Col>
                        <Col xs="auto" className="mb-0 pl-1" >
                          <FormControl>
                            <RadioGroup row aria-labelledby="demo-row-radio-buttons-group-label" name="row-radio-buttons-group">
                              <FormControlLabel style={{ fontSize: "14px" }} disabled={disabled} value="xray" control={<InputRadio checked={xray === true} onClick={(e: any) => setXray(true)} />} label={t('APPOINTMENT.FORM.HAS_XRAY')} />
                              <FormControlLabel style={{ fontSize: "14px" }} disabled={disabled} value="nonxray" control={<InputRadio checked={xray === false} onClick={(e: any) => setXray(false)} />} label={t('APPOINTMENT.FORM.NOT_HAS_XRAY')} />
                            </RadioGroup>
                          </FormControl>
                        </Col>
                      </Row>
                    </Col>
                  )}
                </Row>
                {(renderForm('xray') && renderForm('lab')) !== 'd-none' && <hr style={{ margin: "1rem 0 1rem 0 " }} />}

                <div className={`d-flex mb-3 ${checkPackage(PACKAGE_ADDONS.ADDON_X_RAY) || checkPackage(PACKAGE_ADDONS.ADDON_LAB) ? 'mt-2' : ''} ${renderForm('prictice')}`}>
                  <TextAreaInput
                    rows={2}
                    disabled={disabled}
                    onChange={(event) => {
                      clearErrorMessage()
                      setPractice([event.target.value])
                    }}
                    value={valInputTextArea(practice.toString())}
                    label={t('APPOINTMENT.FORM.PRACTICE')}
                    required={renderReqDisForm('prictice')}
                    helperText={errorMessage?.PRACTICE_REQUIRED || ''}
                    fullWidth
                    maxLength={500}
                    inputProps={{
                      style: {
                        display: 'flex',
                        justifyContent: 'flex-end',
                        alignItems: 'flex-start',
                        fontSize: "12px"
                      },
                      startAdornment: (
                        <Box sx={{ position: "absolute", bottom: "2px" }}>
                          <Box sx={{ fontSize: '12px', color: '#808080' }}>{`${valInputTextArea(practice.toString())?.length || 0}/500`}</Box>
                        </Box>
                      ),
                    }}
                  />
                  <Box className='input-form-note-wrap position-absolute'></Box>
                  <ButtonCustom disabled={disabled} onClick={() => templateText('PRATICE')} textButton={<img src={icons.iconFeatherEdit} alt="" style={{ width: 24 }} />} className="h-100" style={{ margin: 0, height: '86px' }} />
                </div>
                <div className={`d-flex mt-2  ${renderForm('note')}`} style={{ marginBottom: props.appointmentId && !disabled && (props?.patientIdApp?.patientId || isEditApp) ? "0px" : "76px" }}>
                  <TextAreaInput
                    rows={2}
                    onChange={(event) => {
                      clearErrorMessage()
                      setRemark([event.target.value])
                    }}
                    disabled={disabled}
                    value={valInputTextArea(remark.toString())}
                    label={t('APPOINTMENT.FORM.REMARK')}
                    required={renderReqDisForm('note')}
                    helperText={errorMessage?.REMARK_REQUIRED || ''}
                    fullWidth
                    maxLength={500}
                    inputProps={{
                      style: {
                        display: 'flex',
                        justifyContent: 'flex-end',
                        alignItems: 'flex-start',
                        fontSize: "12px"
                      },
                      startAdornment: (
                        <Box sx={{ position: "absolute", bottom: "2px" }}>
                          <Box sx={{ fontSize: '12px', color: '#808080' }}>{`${valInputTextArea(remark.toString())?.length || 0}/500`}</Box>
                        </Box>
                      ),
                    }}
                  />
                  <Box className='input-form-note-wrap position-absolute'></Box>
                  <ButtonCustom disabled={disabled} onClick={() => templateText('REMARK')} textButton={<img src={icons.iconFeatherEdit} alt="" style={{ width: 24 }} />} className="h-100" style={{ margin: 0, height: '86px' }} />
                </div>
                {
                  props.appointmentId && !disabled && (props?.patientIdApp?.patientId || isEditApp) &&
                  <div className={`d-flex mt-2 `} style={{ marginBottom: "25px" }}>
                    <InputTextarea disabled={disabled} value={valInputTextArea(appRemark.toString())} onchange={(event) => setAppRemark([event.target.value])} label={t('APPOINTMENT.FORM.APP_REMARK')} helperText={''} />
                    <Box className='input-form-note-wrap position-absolute'></Box>
                    <ButtonCustom disabled={disabled} onClick={() => templateText('APP')} textButton={<img src={icons.iconFeatherEdit} alt="" style={{ width: 24 }} />} className="h-100" style={{ margin: 0, height: '89px' }} />
                  </div>
                }
              </div >
            </div >
            <ModalSliceFooter style={{ width: "100%" }}>
              <div className={`mb-2  ${width > 575 && 'w-100'} px-3`}>
                <Box display={'flex'} flexDirection={'row'} justifyContent={'space-between'}>
                  <Box sx={{ left: 0 }}>
                    {props.appointmentId && !disabled &&
                      <MainButton
                        title={!disabled ? t('APPOINTMENT.BUTTON.DEL') : ''}
                        type='danger'
                        variant='outlined'
                        disabled={permissions.isDelete.disabled}
                        onClick={() => {
                          // setIsOpenAlertModal(true)
                          handleDeleteClick(Number(props.appointmentId))
                        }}
                        style={{ width: '150px' }}
                      />
                    }
                  </Box>
                  <Box display={'flex'} flexDirection={'row'}>
                    <Box>
                      <MainButton
                        title={t('APPOINTMENT.BUTTON.CANCEL')}
                        type='secondary'
                        variant='outlined'
                        onClick={() => { resetForm() }}
                        style={{ width: '120px', marginRight: '8px' }}
                      />
                    </Box>
                    <Box>
                      <MainButton
                        title={props.appointmentId && !disabled ? props?.patientIdApp?.patientId && t('APPOINTMENT.FORM.ADD') || t('APPOINTMENT.FORM.SAVE') : disabled ? t('APPOINTMENT.FORM.SAVE_SPECIALINFO') : t('APPOINTMENT.FORM.ADD')}
                        type='primary'
                        variant='contained'
                        onClick={() => { handleSubmit() }}
                        disabled={isSubmit || (loading || false)}
                        style={{ width: '120px' }}
                      />
                    </Box>
                  </Box>
                </Box>
              </div>
            </ModalSliceFooter>
          </ModalSlice >
        </>}

      <PageModal
        isOpen={isLabOrderModalOpen}
        size={'M'}
        title={t('APPOINTMENT.LAB_ORDER.BUTTON.SELECT_LAB')}
        handleClose={() => {
          setSearchLab('')
          setPage(1)
          setIsLabOrderModalOpen(false)
        }}
        onSubmit={{ onClick: () => handleConfirmSelectLabOrder() }}
        onCancel={{
          onClick: () => {
            setSearchLab('')
            setPage(1)
            setIsLabOrderModalOpen(false)
          }
        }}
      ><Box>
          <Grid container>
            <Grid xs={12} sm={6} md={6} xl={5} marginY={'16px'} >
              <TextInput
                label={t('APPOINTMENT.LAB_ORDER.SEARCH')}
                value={searchLab}
                onChange={(event) => {
                  setPage(1)
                  setSearchLab(event.target.value)
                }}
                fullWidth
                inputProps={{
                  endAdornment: (
                    <InputAdornment position="end" >
                      {!searchLab ? <FontAwesomeIcon icon={faSearch} style={{ color: 'rgba(0, 0, 0, 0.6)', fontSize: 15 }} /> :
                        <FontAwesomeIcon
                          icon={faTimes}
                          onClick={() => {
                            setSearchLab('');
                            setPage(1)
                          }}
                          style={{ color: 'rgba(0, 0, 0, 0.6)', fontSize: 17, cursor: 'pointer' }} />}
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid xs={12} sm={6} md={4} xl={3} marginY={'16px'}>
              <MainButton
                title={t('INPUT.SEARCH')}
                type='primary'
                variant='contained'
                style={{
                  marginLeft: '16px',
                  width: '120px'
                }}
                onClick={() => {
                  fetchLabOrders(false, true)
                }}
              />
            </Grid>
          </Grid>
          <div
            id="labOrderScrollableDiv"
            style={{ height: getBoxHeight(window.innerWidth, window.innerHeight), minHeight: 0, overflow: 'auto' }}
            onScroll={(event: any) => {
              const target = event.target;
              const isAtBottom = target.scrollHeight - target.scrollTop <= target.clientHeight + 50;
              if (isAtBottom) {
                handleLoadMoreLabOrders();
              }
            }}
          >
            {labOrdersList.map((order: any) => {
              const isSelected = stampSelectedLabOrders.some(o => o.labOrderId === order.labOrderId);
              const handleModalDeselect = () => {
                setStampSelectedLabOrders(prev => prev.filter(o => o.labOrderId !== order.labOrderId));
              };
              return (
                <div key={order.labOrderId}>
                  {LabOrderCard(t, order, date, isSelected, handleSelectLabOrder, handleModalDeselect, true)}
                </div>
              )
            })}

            {loadingLabOrders && page === 1 && <div style={{ display: 'flex', justifyContent: 'center', textAlign: 'center', marginTop: '48px' }}><Loading show={true} type='softLoading' /></div>}
            {!loadingLabOrders && labOrdersList.length === 0 && (
              <div style={{ display: 'flex', justifyContent: 'center', textAlign: 'center', marginTop: '48px' }}>
                <Typography>{t('REPORT.TITLE.NO_DATA')}</Typography>
              </div>
            )}
          </div>
        </Box>
      </PageModal >
    </>
  ) || (
      <></>
    )
}


const getBoxHeight = (width: number, height: number): number => {
  if (width < 300 || height < 600) return 200;
  if (width < 400 || height < 700) return 250;
  if (width < 450 || height < 800) return 430;
  if (width < 800 || height < 900) return 440;
  if (width < 1200 || height < 900) return 450;
  if (width < 1450 || height < 900) return 510;
  if (width < 1700 || height < 1000) return 550;
  return 600;
};


const LabOrderCardContainer = styled(Box)(({ theme }) => ({
  backgroundColor: '#fff',
  borderRadius: '8px',
  padding: '16px',
  marginBottom: '12px',
  boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.05)',
  border: '1px solid #f0f0f0',
}));

export const LabOrderCard = (t: any, order: any, dateAppointment: any, selected?: boolean, onSelect?: (order: any) => void, onDeselect?: () => void, typeModal?: boolean) => {
  const handleContainerClick = () => {
    if (onSelect) {
      onSelect(order);
    }
  };

  const handleDeselectClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (onDeselect) {
      onDeselect();
    }
  };
  return <LabOrderCardContainer key={order?.labOrderId}>
    <Box display="flex" justifyContent="space-between" alignItems="flex-start">
      <Box>
        <Typography variant="body2" color="text.secondary">
          {t('APPOINTMENT.LAB_ORDER.ORDER')}: {order?.labOrderNumber} {t('APPOINTMENT.LAB_ORDER.COMPANY')}:{' '}
          <Tooltip title={order?.labCompanyName || ''}>
            <Box
              component="span"
              sx={{
                display: 'inline-block',
                maxWidth: `${window.innerWidth / 2}px`,
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                verticalAlign: 'bottom',
              }}
            >
              {order?.labCompanyName}
            </Box>
          </Tooltip>
        </Typography>
        <Typography variant="subtitle1" fontWeight="bold" sx={{ my: 1 }}>
          {order?.operativeName}
        </Typography>
        <Box display="flex" flexWrap="wrap"
        >{renderStatusLab(order?.labOrderStatus, t)}</Box>
      </Box>
      <Box textAlign="right">
        <Typography variant="caption" display="block">
          {t('APPOINTMENT.LAB_ORDER.APPOINTMENT')}: {dateToView(dateAppointment)}
        </Typography>
        <Typography variant="caption" display="block" sx={{ mb: 1 }}>
          {t('APPOINTMENT.LAB_ORDER.RECEIVE_LAB')}: {dateToView(order?.dateImport)}
        </Typography>
        {!selected ? <MainButton title={t('APPOINTMENT.LAB_ORDER.BUTTON.SELECT')} type='primary' variant='outlined' height='32px' style={{ cursor: onSelect ? 'pointer' : 'default', marginTop: '12px', width: '70px' }} onClick={handleContainerClick} />
          : <MainButton title={t('APPOINTMENT.LAB_ORDER.BUTTON.UNLINK_APPOINTMENT')} type='danger' variant='outlined' height='32px' style={{ cursor: onSelect ? 'pointer' : 'default', marginTop: '12px', width: '70px' }} onClick={handleDeselectClick} />}
      </Box>
    </Box>
  </LabOrderCardContainer>
}


export const renderStatusLab = (labOrderStatus: any, t: any) => {
  let bgColor: any = colors.themeMainColor
  let label: any = ''
  let icon: any

  if (labOrderStatus === 'ORDER_LAB') {
    bgColor = '#7e57c2'; // สีม่วง - สั่ง LAB
    label = t('LAB_ORDER.QUEUE.ORDER_LAB', 'สั่ง LAB'); // 'สั่ง LAB' คือข้อความสำรอง
    icon = <PlaylistAddOutlinedIcon sx={{ fontSize: '16px', marginRight: '3px' }} />;
  } else if (labOrderStatus === 'SEND_LAB') {
    bgColor = '#29b6f6'; // สีฟ้า - ส่ง Lab
    label = t('LAB_ORDER.QUEUE.SEND_LAB', 'ส่ง LAB');
    icon = <LocalShippingOutlinedIcon sx={{ fontSize: '16px', marginRight: '3px' }} />;
  } else if (labOrderStatus === 'RECEIVE_LAB') {
    bgColor = '#66bb6a'; // สีเขียว - รับชิ้นงานแล้ว
    label = t('LAB_ORDER.QUEUE.RECEIVE_LAB', 'รับชิ้นงานแล้ว');
    icon = <TaskAltOutlinedIcon sx={{ fontSize: '16px', marginRight: '3px' }} />;
  } else if (labOrderStatus === 'RECEIVE_BILL') {
    bgColor = '#ffa726'; // สีส้ม - รับใบเสร็จแล้ว
    label = t('LAB_ORDER.QUEUE.RECEIVE_BILL', 'รับใบเสร็จแล้ว');
    icon = <ReceiptLongOutlinedIcon sx={{ fontSize: '16px', marginRight: '3px' }} />;
  } else if (labOrderStatus === 'REPLY_LAB') {
    bgColor = '#ef5350'; // สีแดง - ตีกลับ LAB
    label = t('LAB_ORDER.QUEUE.REPLY_LAB', 'ตีกลับ LAB');
    icon = <ReplayOutlinedIcon sx={{ fontSize: '16px', marginRight: '3px' }} />;
  } else {
    bgColor = '#f7b928';
    label = `${t('APPOINTMENT.LAB_ORDER.RECEIVE_LAB')} ${labOrderStatus}`
    icon = <ScienceIcon sx={{ fontSize: '16px', marginRight: '3px' }} />
  }

  return <Box
    sx={{
      display: 'inline-flex',
      alignItems: 'center',
      padding: '0px 6px',
      borderRadius: '16px',
      backgroundColor: `${bgColor}20`,
      color: bgColor,
      border: `1px solid ${bgColor}`,
      fontSize: '12px',
      height: '20px',
      maxHeight: '20px',
      boxSizing: 'border-box',
    }}
  >{icon}{label}</Box>
}